// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── AI Assistant Panel ──────────────────────────────────────────────────────
   Color palette: Atlas (mediterráneo) — tokens --accent / --accent-hover /
   --accent-soft definidos en src/index.html :root.
   Dark panel to contrast against the white BPMN canvas.
   ─────────────────────────────────────────────────────────────────────────── */

/* ── Panel container ────────────────────────────────────────────────────── */
.ai-panel {
  position: fixed;
  top: 47px;
  right: 0;
  width: 360px;
  height: calc(100vh - 71px);
  background: #111c2e;
  color: #e2e8f0;
  font-size: 13px;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 250ms ease;
  z-index: 800;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.35);
}

.ai-panel.is-open {
  transform: translateX(0);
}

/* Chat open + no selection → keep hidden */
body:has(#ai-panel.is-open) #properties.is-hidden {
  right: -320px;
  pointer-events: none;
}
/* Chat open + node selected → show beside the chat panel */
body:has(#ai-panel.is-open) #properties:not(.is-hidden) {
  right: 360px;
}

/* Shrink only the DMN content (not the whole overlay) so the top bar keeps
   its full width and its actions (Guardar, Importar XML…) don't shift when
   the chat opens. Only applies to full mode — the popup modal doesn't
   stretch to the chat panel and the dock mode relocates the chat. */
body:has(#ai-panel.is-open) #dmn-overlay.mode-full .dmn-overlay-content {
  margin-right: 360px;
}

/* In full DMN mode the chat sits below the DMN top bar (44px) so the bar's
   actions stay accessible above the chat header. */
body:has(#dmn-overlay.mode-full.show) .ai-panel {
  top: 44px;
  height: calc(100vh - 68px);
}

/* ── Header ─────────────────────────────────────────────────────────────── */
.ai-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  background: #0d1b2e;
  border-bottom: 1px solid #1e293b;
  color: var(--accent-soft, #4A90B8);
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  gap: 8px;
}

.ai-panel__brand {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  letter-spacing: 0.02em;
}

.ai-panel__brand svg { flex-shrink: 0; }

.ai-panel__header-actions {
  display: flex;
  gap: 4px;
}

.ai-panel__header button {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1;
  transition: color 150ms, background 150ms;
}

.ai-panel__header button:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.07);
}

/* ── Tabs bar ────────────────────────────────────────────────────────────── */
.ai-panel__tabs {
  display: flex;
  align-items: stretch;
  background: #0d1b2e;
  border-bottom: 1px solid #2d3748;
  overflow-x: auto;
  flex-shrink: 0;
  scrollbar-width: none;
  min-height: 30px;
}
.ai-panel__tabs::-webkit-scrollbar { display: none; }

.ai-tab {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  font-size: 11px;
  font-family: inherit;
  background: transparent;
  border: none;
  border-right: 1px solid #2d3748;
  color: #718096;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  max-width: 130px;
  transition: color 150ms, background 150ms;
}
.ai-tab:hover { color: #e2e8f0; background: #0f2035; }
.ai-tab.is-active {
  color: #e2e8f0;
  background: #111c2e;
  border-bottom: 2px solid var(--accent);
  margin-bottom: -1px;
}

.ai-tab__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90px;
}

.ai-tab__close {
  font-size: 14px;
  line-height: 1;
  flex-shrink: 0;
  color: inherit;
  opacity: 0.45;
  transition: opacity 150ms, color 150ms;
  cursor: pointer;
  padding: 0 1px;
  border-radius: 2px;
}
.ai-tab__close:hover { opacity: 1; color: #fc8181; }

.ai-tab--new {
  font-size: 16px;
  padding: 3px 10px;
  color: #64748b;
  flex-shrink: 0;
  margin-left: auto;
  border-right: none;
}
.ai-tab--new:hover { color: var(--accent); background: transparent; }

/* ── Context pill ───────────────────────────────────────────────────────── */
.ai-panel__context {
  padding: 7px 12px;
  background: #16213e;
  border-bottom: 1px solid #2d3748;
  flex-shrink: 0;
}

.ai-context-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #2d3748;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 11px;
  color: #94a3b8;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Scenario 2 — BPMN selection active */
.ai-context-pill.is-selection {
  background: #1e3a5f;
  color: var(--accent-soft);
  border: 1px solid rgba(44, 95, 141, 0.4);
}

/* Scenario 3 — DMN rules mode */
.ai-context-pill.is-rules {
  background: #0d2e2e;
  color: #2dd4bf;
  border: 1px solid rgba(14, 116, 144, 0.4);
}

/* Panel header stripe per mode */
.ai-panel.is-mode-selection .ai-panel__header {
  border-bottom: 2px solid var(--accent);
}

.ai-panel.is-mode-rules .ai-panel__header {
  border-bottom: 2px solid #0e7490;
}

/* ── Selection list (multi-element lasso) ───────────────────────────────── */
.ai-selection-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
  max-height: 80px;
  overflow-y: auto;
}

.ai-selection-list::-webkit-scrollbar { width: 3px; }
.ai-selection-list::-webkit-scrollbar-thumb { background: #4a5568; border-radius: 2px; }

.ai-sel-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #1e2d40;
  border: 1px solid #2d4a6a;
  border-radius: 6px;
  padding: 2px 7px;
  font-size: 10px;
  color: #90cdf4;
  max-width: 140px;
  overflow: hidden;
}

.ai-sel-item__type {
  color: #4a90d9;
  font-size: 9px;
  text-transform: uppercase;
  flex-shrink: 0;
}

.ai-sel-item__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Messages area ──────────────────────────────────────────────────────── */
.ai-panel__messages {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  scroll-behavior: smooth;
}

.ai-panel__messages::-webkit-scrollbar {
  width: 4px;
}
.ai-panel__messages::-webkit-scrollbar-track {
  background: transparent;
}
.ai-panel__messages::-webkit-scrollbar-thumb {
  background: #4a5568;
  border-radius: 4px;
}

/* ── Empty state ────────────────────────────────────────────────────────── */
.ai-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
  text-align: center;
  gap: 8px;
  padding: 24px;
  pointer-events: none;
}

.ai-empty-state p:first-child {
  font-size: 28px;
  margin: 0;
}

.ai-empty-state p:last-child {
  font-size: 13px;
  margin: 0;
  color: #718096;
}

/* ── Message bubbles ────────────────────────────────────────────────────── */
.ai-msg {
  max-width: 92%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* AI messages: row layout — avatar on left, body on right */
.ai-msg.is-ai,
.ai-msg.is-error {
  align-self: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  max-width: 96%;
}

.ai-msg.is-user {
  align-self: flex-end;
}

/* Avatar circle */
.ai-msg__avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-soft) 100%);
  box-shadow: 0 2px 8px rgba(44, 95, 141, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: white;
  flex-shrink: 0;
  margin-top: 2px;
  user-select: none;
}

/* Body wrapper inside AI row */
.ai-msg__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
}

/* Timestamp */
.ai-msg__time {
  font-size: 10px;
  color: #64748b;
  padding: 0 2px;
  flex-shrink: 0;
}
.ai-msg.is-user .ai-msg__time {
  text-align: right;
}

.ai-msg__bubble {
  padding: 9px 13px;
  border-radius: 12px;
  line-height: 1.6;
  word-break: break-word;
}

/* ── AI bubble: glassmorphism slate ──────────────────────────────────── */
.ai-msg.is-ai .ai-msg__bubble {
  background: rgba(30, 41, 59, 0.92);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(44, 95, 141, 0.22);
  border-left: 3px solid rgba(44, 95, 141, 0.55);
  border-bottom-left-radius: 4px;
  color: #e2e8f0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

/* ── User bubble: gradient ───────────────────────────────────────────── */
.ai-msg.is-user .ai-msg__bubble {
  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-soft) 100%);
  color: white;
  border-bottom-right-radius: 4px;
  white-space: pre-wrap;
  box-shadow: 0 2px 10px rgba(44, 95, 141, 0.4);
}

/* ── System note (THEMIS_DMN_PLAN §4.6 — decision scope hand-off) ────── */
.ai-msg.is-system {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}
.ai-msg.is-system .ai-msg__bubble--system {
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-soft, #a0aec0);
  border: 1px dashed rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  font-style: italic;
  max-width: 80%;
  text-align: center;
}

/* ── Error bubble ────────────────────────────────────────────────────── */
.ai-msg.is-error .ai-msg__bubble {
  background: rgba(45, 21, 21, 0.9);
  color: #fc8181;
  border: 1px solid #742a2a;
  border-left: 3px solid #e53e3e;
  border-bottom-left-radius: 4px;
  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.15);
}

/* ── Markdown: strong accent color ──────────────────────────────────── */
.ai-msg.is-ai .ai-msg__bubble strong,
.ai-msg.is-error .ai-msg__bubble strong {
  color: var(--accent-soft);
  font-weight: 600;
}

/* ── Markdown: paragraphs ────────────────────────────────────────────── */
.ai-msg.is-ai .ai-msg__bubble p,
.ai-msg.is-error .ai-msg__bubble p,
.ai-issue__desc p,
.ai-issue__suggestion p {
  margin: 0 0 6px;
}
.ai-msg.is-ai .ai-msg__bubble p:last-child,
.ai-msg.is-error .ai-msg__bubble p:last-child,
.ai-issue__desc p:last-child,
.ai-issue__suggestion p:last-child {
  margin-bottom: 0;
}

/* ── Markdown: lists (ul + ol) ───────────────────────────────────────── */
.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list,
.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list,
.ai-msg.is-error .ai-msg__bubble ul.ai-md-list,
.ai-msg.is-error .ai-msg__bubble ol.ai-md-list,
.ai-issue__desc ul.ai-md-list,
.ai-issue__desc ol.ai-md-list {
  margin: 4px 0 6px;
  padding-left: 20px;
}
.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li,
.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li,
.ai-msg.is-error .ai-msg__bubble ul.ai-md-list li,
.ai-msg.is-error .ai-msg__bubble ol.ai-md-list li,
.ai-issue__desc ul.ai-md-list li,
.ai-issue__desc ol.ai-md-list li {
  margin-bottom: 4px;
}
.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li::marker,
.ai-msg.is-error .ai-msg__bubble ul.ai-md-list li::marker {
  color: var(--accent-soft);
}
.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li::marker,
.ai-msg.is-error .ai-msg__bubble ol.ai-md-list li::marker {
  color: var(--accent-soft);
  font-weight: 700;
}

/* ── Markdown: inline code ───────────────────────────────────────────── */
.ai-msg.is-ai .ai-msg__bubble code,
.ai-msg.is-error .ai-msg__bubble code,
.ai-issue__desc code,
.ai-issue__suggestion code {
  background: rgba(44, 95, 141, 0.15);
  border: 1px solid rgba(44, 95, 141, 0.3);
  color: var(--accent-soft);
  padding: 1px 5px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 11px;
}

/* ── Inline action buttons inside AI bubble ─────────────────────────────── */
.ai-msg__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ai-msg__action-btn {
  font-size: 11px;
  padding: 4px 9px;
  border-radius: 6px;
  border: 1px solid #4a5568;
  background: transparent;
  color: #a0aec0;
  cursor: pointer;
  transition: all 150ms;
  font-family: inherit;
}

.ai-msg__action-btn:hover {
  background: #374151;
  color: #e2e8f0;
  border-color: #6b7280;
}

.ai-msg__action-btn.is-primary {
  background: var(--accent);
  color: white;
  border-color: var(--accent);
}

.ai-msg__action-btn.is-primary:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}

.ai-msg__action-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}

.ai-msg__action-btn.is-applied {
  background: #166534;
  border-color: #166534;
  color: #86efac;
  opacity: 1;
}

.ai-msg__action-btn.is-dismissed {
  background: transparent;
  border-color: #374151;
  color: #4b5563;
  opacity: 1;
  text-decoration: line-through;
}

/* ── Suggestion option pills ─────────────────────────────────────────────── */
.ai-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.ai-suggestion-btn {
  font-size: 12px;
  padding: 5px 11px;
  border-radius: 14px;
  border: 1px solid #4a5568;
  background: #1e293b;
  color: #cbd5e1;
  cursor: pointer;
  transition: all 150ms;
  font-family: inherit;
  line-height: 1.3;
}

.ai-suggestion-btn:hover {
  background: #334155;
  color: #f1f5f9;
  border-color: #60a5fa;
}

.ai-suggestion-btn.is-selected {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}

.ai-suggestion-btn:disabled {
  cursor: not-allowed;
}

.ai-suggestion-btn:disabled:not(.is-selected) {
  opacity: 0.3;
}

/* ── Loading bubble (typing indicator) ─────────────────────────────────── */
.ai-msg.is-loading .ai-msg__bubble {
  padding: 10px 14px;
}

.ai-typing {
  display: flex;
  gap: 4px;
  align-items: center;
}

.ai-typing__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #718096;
  animation: ai-bounce 1s infinite;
}

.ai-typing__dot:nth-child(2) { animation-delay: 0.15s; }
.ai-typing__dot:nth-child(3) { animation-delay: 0.30s; }

@keyframes ai-bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: 0.6; }
  40%           { transform: translateY(-5px); opacity: 1; }
}

/* ── Chips ──────────────────────────────────────────────────────────────── */
.ai-panel__chips {
  padding: 8px 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  border-top: 1px solid #2d3748;
  flex-shrink: 0;
  min-height: 40px;
}

.ai-chip {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 12px;
  border: 1px solid #4a5568;
  background: #2d3748;
  color: #cbd5e0;
  cursor: pointer;
  white-space: nowrap;
  transition: all 150ms;
  font-family: inherit;
  line-height: 1.4;
}

.ai-chip:hover {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}

/* ── Input area ─────────────────────────────────────────────────────────── */
.ai-panel__input-area {
  padding: 10px 12px;
  border-top: 1px solid #2d3748;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.ai-include-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #718096;
  cursor: pointer;
  user-select: none;
}

.ai-include-label input[type="checkbox"] {
  accent-color: var(--accent);
  width: 12px;
  height: 12px;
  cursor: pointer;
}

.ai-input-row {
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

#ai-input {
  flex: 1;
  background: #2d3748;
  border: 1px solid #4a5568;
  border-radius: 8px;
  color: #e2e8f0;
  padding: 8px 10px;
  font-size: 12px;
  font-family: inherit;
  resize: none;
  outline: none;
  transition: border-color 150ms;
  line-height: 1.5;
}

#ai-input:focus {
  border-color: var(--accent);
}

#ai-input::placeholder {
  color: #64748b;
}

.ai-send-btn {
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  font-size: 16px;
  transition: background 150ms;
}

.ai-send-btn:hover:not(:disabled) {
  background: var(--accent-hover);
}

.ai-send-btn:disabled {
  background: #374151;
  color: #6b7280;
  cursor: not-allowed;
}

/* ── FAB ────────────────────────────────────────────────────────────────── */
.ai-fab {
  position: fixed;
  bottom: 40px;
  right: 16px;
  z-index: 900;
  background: var(--accent, #2C5F8D);
  color: #fff;
  border: none;
  border-radius: 22px;
  height: 40px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  box-shadow: 0 4px 14px rgba(44, 95, 141, 0.45);
  cursor: pointer;
  font-size: 13px;
  font-family: inherit;
  font-weight: 600;
  transition: right 250ms ease, background 200ms, box-shadow 200ms;
}

.ai-fab:hover {
  background: var(--accent-hover, #1E4A70);
  color: #fff;
  box-shadow: 0 6px 18px rgba(44, 95, 141, 0.55);
}

.ai-fab__label {
  max-width: 0;
  margin-left: 0;
  overflow: hidden;
  white-space: nowrap;
  transition: max-width 200ms ease, margin-left 200ms ease;
}

.ai-fab:hover .ai-fab__label {
  max-width: 80px;
  margin-left: 7px;
}

.ai-fab.is-hidden {
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms;
}

/* Shift AI FAB left when properties panel is open (chat is closed) */
body:has(#properties:not(.is-hidden)):not(:has(#ai-panel.is-open)) .ai-fab {
  right: 336px; /* 320 props + 16 base */
}

/* Reset FAB to default when DMN overlay is open (properties panel is hidden behind the overlay) */
body:has(#dmn-overlay.show):not(:has(#ai-panel.is-open)) .ai-fab {
  right: 16px;
}


/* ── Generate process modal ──────────────────────────────────────────────── */
.ai-gen-modal {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ai-gen-modal[hidden] { display: none; }

.ai-gen-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
}

.ai-gen-modal__box {
  position: relative;
  width: 680px;
  max-width: 94vw;
  background: #111c2e;
  border: 1px solid #1e3a5f;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5);
  overflow: hidden;
  transition: width 220ms ease;
  animation: ai-modal-in 180ms ease;
}
.ai-gen-modal__box.is-wide {
  width: 860px;
}
@keyframes ai-modal-in {
  from { opacity: 0; transform: translateY(-12px) scale(.97); }
  to   { opacity: 1; transform: translateY(0)     scale(1);   }
}

.ai-gen-modal__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: var(--accent);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.ai-gen-modal__close {
  background: none;
  border: none;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  opacity: .8;
  transition: opacity 150ms;
}
.ai-gen-modal__close:hover { opacity: 1; }

/* ── Steps (wizard panels) ───────────────────────────────────────────────── */
.ai-gen-step { display: block; }
.ai-gen-step[hidden] { display: none; }

.ai-gen-modal__body {
  padding: 18px 18px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-gen-modal__hint {
  margin: 0;
  font-size: 12px;
  color: #a0aec0;
}

/* Textarea in step 1 */
#ai-gen-input {
  width: 100%;
  box-sizing: border-box;
  background: #2d3748;
  border: 1px solid #4a5568;
  border-radius: 8px;
  color: #e2e8f0;
  font-size: 13px;
  line-height: 1.6;
  padding: 10px 12px;
  resize: vertical;
  outline: none;
  transition: border-color 150ms;
  font-family: inherit;
}
#ai-gen-input:focus { border-color: var(--accent); }
#ai-gen-input::placeholder { color: #64748b; }

/* ── Mic button — prominent, full-width row ──────────────────────────────── */
.ai-gen-mic-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  padding: 9px 14px;
  background: #2d3748;
  border: 1px dashed #4a5568;
  border-radius: 8px;
  color: #a0aec0;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: background 150ms, border-color 150ms, color 150ms;
}
.ai-gen-mic-btn:hover:not(:disabled) {
  background: #374151;
  border-color: #718096;
  color: #e2e8f0;
}
.ai-gen-mic-btn.is-recording {
  background: #2d1515;
  border-color: #ef4444;
  border-style: solid;
  color: #fc8181;
}
.ai-gen-mic-btn.is-transcribing {
  background: #0f1f3d;
  border-color: #3b82f6;
  border-style: solid;
  color: var(--accent-soft);
}
.ai-gen-mic-btn:disabled:not(.is-transcribing) {
  opacity: .35;
  cursor: not-allowed;
}
.ai-gen-mic-btn.is-transcribing {
  cursor: default;
}

/* ── Waveform bars (shown when recording) ──────────────────────────────── */
.ai-mic-bars {
  display: none;
  align-items: flex-end;
  gap: 3px;
  height: 16px;
}
.ai-mic-bars i {
  display: block;
  width: 3px;
  background: currentColor;
  border-radius: 2px;
  transform-origin: bottom;
}
.ai-mic-bars i:nth-child(1) { height: 40%; animation: sound-bar 0.7s ease-in-out infinite alternate 0s;    }
.ai-mic-bars i:nth-child(2) { height: 80%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.15s; }
.ai-mic-bars i:nth-child(3) { height: 100%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.05s; }
.ai-mic-bars i:nth-child(4) { height: 55%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.25s; }
@keyframes sound-bar {
  0%   { transform: scaleY(0.2); opacity: 0.6; }
  100% { transform: scaleY(1);   opacity: 1;   }
}
.ai-gen-mic-btn.is-recording .ai-mic-bars { display: flex; }
.ai-gen-mic-btn.is-recording .ai-mic-icon { display: none; }
.ai-gen-mic-btn.is-transcribing .ai-mic-icon { display: none; }
.ai-gen-mic-btn.is-transcribing .ai-mic-bars { display: none; }

/* ── Steps list (preview step) ───────────────────────────────────────────── */
.ai-gen-steps-list {
  margin: 0;
  padding-left: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 340px;
  overflow-y: auto;
}
.ai-gen-steps-list li {
  font-size: 13px;
  color: #e2e8f0;
  line-height: 1.6;
  padding: 4px 0;
  border-bottom: 1px solid #2d3748;
}
.ai-gen-steps-list li:last-child {
  border-bottom: none;
}

/* ── Description block (preview step) ───────────────────────────────────── */
.ai-gen-description {
  margin: 0 0 12px;
  font-size: 13px;
  color: #a0aec0;
  line-height: 1.6;
  padding: 10px 12px;
  background: #16213e;
  border-radius: 8px;
  border-left: 3px solid var(--accent);
  font-style: italic;
}

/* ── Loading step ────────────────────────────────────────────────────────── */
.ai-gen-loading-body {
  align-items: center;
  justify-content: center;
  padding: 36px 18px;
  gap: 14px;
  text-align: center;
  min-height: 160px;
}

.ai-gen-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #2d3748;
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: ai-spin 0.8s linear infinite;
  flex-shrink: 0;
}
@keyframes ai-spin {
  to { transform: rotate(360deg); }
}

.ai-gen-loading-label {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  transition: opacity 300ms ease;
}

.ai-gen-loading-label.is-fading {
  opacity: 0;
}

.ai-gen-loading-hint {
  margin: 0;
  font-size: 11px;
  color: #718096;
}

/* ── Result step ─────────────────────────────────────────────────────────── */
.ai-gen-result-msg {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #68d391;
}

/* ── Footer ──────────────────────────────────────────────────────────────── */
.ai-gen-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 18px 16px;
  border-top: 1px solid #2d3748;
}

.ai-gen-modal__btn {
  padding: 7px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #4a5568;
  background: #2d3748;
  color: #e2e8f0;
  font-family: inherit;
  transition: background 150ms;
}
.ai-gen-modal__btn:hover:not(:disabled) { background: #1e3a5f; }

.ai-gen-modal__btn--primary {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}
.ai-gen-modal__btn--primary:hover:not(:disabled) { background: var(--accent-hover); }
.ai-gen-modal__btn--primary:disabled {
  opacity: .45;
  cursor: not-allowed;
}


/* ── Voice button in main input row ─────────────────────────────────────── */
.ai-voice-btn {
  position: relative;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #2d3748;
  border: 1px solid #4a5568;
  color: #718096;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
  transition: background 150ms, border-color 150ms, color 150ms;
  line-height: 1;
  overflow: visible;
}
.ai-voice-btn:hover:not(:disabled) {
  background: #374151;
  color: #e2e8f0;
  border-color: #6b7280;
}
.ai-voice-btn:disabled:not(.is-transcribing) {
  opacity: .3;
  cursor: not-allowed;
}

/* Recording state — ripple rings */
.ai-voice-btn.is-recording {
  background: #7f1d1d;
  border-color: #ef4444;
  color: #fca5a5;
}
.ai-voice-btn.is-recording::before,
.ai-voice-btn.is-recording::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1.5px solid rgba(239, 68, 68, 0.75);
  animation: voice-ripple 1.6s ease-out infinite;
  pointer-events: none;
}
.ai-voice-btn.is-recording::after {
  animation-delay: 0.8s;
}
@keyframes voice-ripple {
  0%   { transform: scale(1);   opacity: 0.8; }
  100% { transform: scale(2.6); opacity: 0;   }
}

/* Transcribing state — blue spinning ring */
.ai-voice-btn.is-transcribing {
  background: #1e3a5f;
  border-color: #3b82f6;
  color: var(--accent-soft);
  cursor: default;
}
.ai-voice-btn.is-transcribing::before {
  content: '';
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #60a5fa;
  border-right-color: #60a5fa;
  animation: voice-spin 0.75s linear infinite;
  pointer-events: none;
}
@keyframes voice-spin {
  to { transform: rotate(360deg); }
}

/* Textarea glow when listening */
#ai-input.is-listening {
  border-color: rgba(239, 68, 68, 0.55) !important;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);
  transition: border-color 200ms, box-shadow 200ms;
}

/* ── Loading label inside bubble ─────────────────────────────────────────── */
.ai-loading-label {
  display: block;
  font-size: 11px;
  color: #a0aec0;
  margin-bottom: 5px;
  transition: opacity 300ms ease;
}

.ai-loading-label.is-fading {
  opacity: 0;
}

/* ── Modal loading label (rotating contextual messages) ──────────────────── */
.ai-gen-loading-label {
  transition: opacity 300ms ease;
}
.ai-gen-loading-label.is-fading {
  opacity: 0;
}

/* ── Steps list (describe response) ─────────────────────────────────────── */
.ai-steps-intro {
  margin: 0 0 8px;
  font-size: 13px;
  color: #e2e8f0;
}

.ai-steps-list {
  margin: 0 0 4px;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ai-steps-list li {
  font-size: 12px;
  color: #cbd5e0;
  line-height: 1.55;
}

/* ── Issues list (validate response) ────────────────────────────────────── */
.ai-issues-intro {
  margin: 0 0 8px;
  font-size: 13px;
  color: #e2e8f0;
}

.ai-issues-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ai-issue {
  background: #1a1a2e;
  border-left: 3px solid #e53e3e;
  border-radius: 0 6px 6px 0;
  padding: 7px 10px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ai-issue__header {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #fc8181;
  font-size: 11px;
  font-weight: 600;
}

.ai-issue__element {
  font-family: monospace;
}

.ai-issue__desc {
  margin: 0;
  font-size: 12px;
  color: #e2e8f0;
  line-height: 1.4;
}
.ai-issue__suggestion {
  margin: 0;
  font-size: 11px;
  color: #a0aec0;
  font-style: italic;
  line-height: 1.4;
}
.ai-issue__suggestion strong { color: var(--accent-soft); font-style: normal; }

.ai-issue .ai-msg__action-btn {
  align-self: flex-start;
  margin-top: 2px;
  font-size: 10px;
  padding: 3px 8px;
}

/* ──────────────────────────────────────────────────────────────────────────
   Themis context: when DMN overlay is open, the chat takes on Themis identity
   (ocre dorado palette). All Atlas-blue accents flip to gold; brand text
   swaps from "⊕ Atlas" to "♎ Themis".
   Tokens (--themis, --themis-hover, --themis-soft, --themis-bg, --themis-border)
   are defined in src/index.html :root.
   ────────────────────────────────────────────────────────────────────────── */

/* Brand swap helpers */
.ai-brand-atlas,
.ai-brand-themis { align-items: center; gap: 6px; }
.ai-brand-atlas { display: inline-flex; }
.ai-brand-themis { display: none; }
body:has(#dmn-overlay.show) .ai-brand-atlas { display: none; }
body:has(#dmn-overlay.show) .ai-brand-themis { display: inline-flex; }

/* FAB icon inherits color from button (white on Atlas blue / black on Themis gold) */

/* Header — only text/icon color changes; bg stays neutral */
body:has(#dmn-overlay.show) .ai-panel__header {
  color: var(--themis-soft);
}

/* Tabs */
body:has(#dmn-overlay.show) .ai-tab.is-active {
  border-bottom-color: var(--themis);
}
body:has(#dmn-overlay.show) .ai-tab--new:hover { color: var(--themis-soft); }

/* Mode stripes (rules-mode default also gets the brand color) */
.ai-panel.is-mode-rules .ai-panel__header { border-bottom: 2px solid var(--themis); }
body:has(#dmn-overlay.show) .ai-panel.is-mode-selection .ai-panel__header {
  border-bottom-color: var(--themis-hover);
}

/* Context pills */
body:has(#dmn-overlay.show) .ai-context-pill.is-selection {
  background: var(--themis-bg);
  color: var(--themis-soft);
  border: 1px solid var(--themis-border);
}
body:has(#dmn-overlay.show) .ai-context-pill.is-rules {
  background: var(--themis-bg);
  color: var(--themis-soft);
  border: 1px solid var(--themis-border);
}

/* Selection list items */
body:has(#dmn-overlay.show) .ai-sel-item {
  background: rgba(var(--themis-rgb), 0.10);
  border-color: rgba(var(--themis-rgb), 0.35);
  color: var(--themis-soft);
}
body:has(#dmn-overlay.show) .ai-sel-item__type { color: var(--themis); }

/* Avatar */
body:has(#dmn-overlay.show) .ai-msg__avatar {
  background: linear-gradient(135deg, var(--themis-hover) 0%, var(--themis) 100%);
  box-shadow: 0 2px 8px rgba(var(--themis-rgb), 0.45);
  color: var(--themis-text);
}

/* AI bubble */
body:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble {
  border-color: rgba(var(--themis-rgb), 0.28);
  border-left-color: rgba(var(--themis-soft-rgb), 0.65);
}

/* User bubble */
body:has(#dmn-overlay.show) .ai-msg.is-user .ai-msg__bubble {
  background: linear-gradient(135deg, var(--themis-hover) 0%, var(--themis) 100%);
  color: var(--themis-text);
  box-shadow: 0 2px 10px rgba(var(--themis-rgb), 0.4);
}

/* Markdown accents (strong, code, list markers) */
body:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble strong,
body:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble strong,
body:has(#dmn-overlay.show) .ai-issue__suggestion strong {
  color: var(--themis-soft);
}
body:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble code,
body:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble code,
body:has(#dmn-overlay.show) .ai-issue__desc code,
body:has(#dmn-overlay.show) .ai-issue__suggestion code {
  background: var(--themis-bg);
  border-color: var(--themis-border);
  color: var(--themis-soft);
}
body:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li::marker,
body:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li::marker,
body:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble ul.ai-md-list li::marker,
body:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble ol.ai-md-list li::marker {
  color: var(--themis-soft);
}

/* Action / suggestion / chip buttons */
body:has(#dmn-overlay.show) .ai-msg__action-btn.is-primary {
  background: var(--themis);
  border-color: var(--themis);
  color: var(--themis-text);
}
body:has(#dmn-overlay.show) .ai-msg__action-btn.is-primary:hover {
  background: var(--themis-hover);
  border-color: var(--themis-hover);
  color: var(--themis-text);
}
body:has(#dmn-overlay.show) .ai-suggestion-btn:hover { border-color: var(--themis-soft); }
body:has(#dmn-overlay.show) .ai-suggestion-btn.is-selected {
  background: var(--themis);
  border-color: var(--themis);
  color: var(--themis-text);
}
body:has(#dmn-overlay.show) .ai-chip:hover {
  background: var(--themis);
  border-color: var(--themis);
  color: var(--themis-text);
}

/* Input + send */
body:has(#dmn-overlay.show) .ai-include-label input[type="checkbox"] { accent-color: var(--themis); }
body:has(#dmn-overlay.show) #ai-input:focus { border-color: var(--themis); }
body:has(#dmn-overlay.show) .ai-send-btn {
  background: var(--themis);
  color: var(--themis-text);
}
body:has(#dmn-overlay.show) .ai-send-btn:hover:not(:disabled) {
  background: var(--themis-hover);
  color: var(--themis-text);
}

/* FAB */
body:has(#dmn-overlay.show) .ai-fab {
  background: var(--themis);
  color: var(--themis-text);
  box-shadow: 0 4px 14px rgba(var(--themis-rgb), 0.45);
}
body:has(#dmn-overlay.show) .ai-fab:hover {
  background: var(--themis-hover);
  color: var(--themis-text);
  box-shadow: 0 6px 18px rgba(var(--themis-rgb), 0.55);
}

/* Description block in modal (BPMN-only, but keep coherent if reused) */
body:has(#dmn-overlay.show) .ai-gen-description { border-left-color: var(--themis); }

/* ──────────────────────────────────────────────────────────────────────────
   Atlas — Generate process modal: PDF drop-zone + typed outline preview
   See plans/actualizacion/ATLAS_BPMN_GENERATION_PLAN.md §3.1, §3.2, §3.3
   ────────────────────────────────────────────────────────────────────────── */

:root {
  --atlas-outline-start:      #16a34a;
  --atlas-outline-end:        #dc2626;
  --atlas-outline-task:       #2563eb;
  --atlas-outline-decision:   #d97706;
  --atlas-outline-gateway:    #7c3aed;
  --atlas-outline-event:      #0891b2;
  --atlas-outline-subprocess: #475569;
  --atlas-outline-message:    #db2777;
  --atlas-bg-soft:            #16213e;
  --atlas-border-soft:        #2d4366;
}

/* ── Drop-zone (paso 1) ─────────────────────────────────────────────────── */
.ai-gen-dropzone {
  margin-top: 12px;
  border: 2px dashed var(--atlas-border-soft);
  border-radius: 8px;
  padding: 14px 16px;
  text-align: center;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
  background: rgba(22, 33, 62, 0.5);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ai-gen-dropzone:hover,
.ai-gen-dropzone:focus {
  background: var(--atlas-bg-soft);
  outline: none;
  border-color: var(--accent);
}
.ai-gen-dropzone.is-dragging {
  background: var(--atlas-bg-soft);
  border-color: var(--accent);
  border-style: solid;
}
.ai-gen-dropzone__label {
  font-size: 13px;
  color: #cbd5e1;
  font-weight: 500;
}
.ai-gen-dropzone__hint {
  font-size: 11px;
  color: #94a3b8;
}

.ai-gen-files {
  list-style: none;
  padding: 0;
  margin: 8px 0 0;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ai-gen-files:empty { display: none; }
.ai-gen-files li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  background: #0f1a2c;
  border: 1px solid #1e3a5f;
  border-radius: 6px;
  color: #cbd5e1;
}
.ai-gen-files .ai-gen-file__name {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-gen-files .ai-gen-file__meta {
  color: #94a3b8;
  font-size: 11px;
}
.ai-gen-files .ai-gen-file__remove {
  background: transparent;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 0 4px;
}
.ai-gen-files .ai-gen-file__remove:hover { color: var(--atlas-outline-end); }
.ai-gen-files li.is-loading { opacity: 0.65; }
.ai-gen-files li.is-error {
  border-color: var(--atlas-outline-end);
  color: var(--atlas-outline-end);
}

/* ── Outline preview (paso 2) ───────────────────────────────────────────── */
.ai-gen-outline {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  line-height: 1.7;
  max-height: 320px;
  overflow-y: auto;
  padding: 12px;
  background: var(--atlas-bg-soft);
  border-radius: 8px;
  border: 1px solid #1e3a5f;
}

.atlas-out {
  display: flex;
  gap: 6px;
  align-items: baseline;
  padding: 3px 6px;
  flex-wrap: wrap;
  position: relative;
  border-radius: 4px;
  border-left: 3px solid transparent;
  transition: background 120ms ease;
}
.atlas-out:hover { background: rgba(148, 163, 184, 0.06); }
.atlas-out__lineno {
  flex: 0 0 auto;
  display: inline-block;
  text-align: right;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: #64748b;
  padding-right: 8px;
  margin-right: 4px;
  border-right: 1px solid rgba(100, 116, 139, 0.25);
  user-select: none;
}
.atlas-out:hover .atlas-out__lineno { color: #94a3b8; }
.atlas-out.has-error .atlas-out__lineno {
  color: var(--atlas-outline-end);
  border-right-color: rgba(220, 38, 38, 0.5);
}
.atlas-out.has-warning .atlas-out__lineno {
  color: var(--atlas-outline-decision);
  border-right-color: rgba(217, 119, 6, 0.5);
}
.atlas-out__indent {
  flex: 0 0 auto;
  display: inline-block;
}
.atlas-out__sym { width: 14px; display: inline-block; text-align: center; }
.atlas-out__prefix {
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
}
.atlas-out__label { flex: 1; color: #e2e8f0; }
.atlas-out__actor { color: #cbd5e1; font-size: 12px; }
.atlas-out__actor-pill {
  display: inline-block;
  padding: 1px 8px;
  background: rgba(148, 163, 184, 0.18);
  border-radius: 999px;
  color: #cbd5e1;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
}
.atlas-out__branch {
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
  padding-right: 4px;
}
.atlas-out__warn { color: var(--atlas-outline-decision); margin-left: 4px; }
.atlas-out__issue {
  margin-left: 4px;
  cursor: help;
  font-size: 12px;
  line-height: 1;
}

/* Vertical guide rendered next to indented branch lines */
.atlas-out__guide {
  position: absolute;
  left: 4px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: rgba(148, 163, 184, 0.3);
  border-radius: 2px;
}

/* Per-prefix tinting for the prefix pill */
.tok-prefix-INICIO     { background: rgba(22, 163, 74, 0.22);  color: #4ade80; }
.tok-prefix-FIN        { background: rgba(220, 38, 38, 0.22);  color: #f87171; }
.tok-prefix-TAREA      { background: rgba(37, 99, 235, 0.22);  color: #60a5fa; }
.tok-prefix-DECISION   { background: rgba(217, 119, 6, 0.22);  color: #fbbf24; }
.tok-prefix-GATEWAY    { background: rgba(124, 58, 237, 0.22); color: #c4b5fd; }
.tok-prefix-EVENTO     { background: rgba(8, 145, 178, 0.22);  color: #67e8f9; }
.tok-prefix-SUBPROCESO { background: rgba(71, 85, 105, 0.32);  color: #cbd5e1; }
.tok-prefix-MENSAJE    { background: rgba(219, 39, 119, 0.22); color: #f472b6; }

.atlas-out--start      { color: var(--atlas-outline-start); }
.atlas-out--end        { color: var(--atlas-outline-end); }
.atlas-out--task       { color: var(--atlas-outline-task); }
.atlas-out--decision   { color: var(--atlas-outline-decision); }
.atlas-out--gateway    { color: var(--atlas-outline-gateway); }
.atlas-out--event      { color: var(--atlas-outline-event); }
.atlas-out--subprocess { color: var(--atlas-outline-subprocess); }
.atlas-out--message    { color: var(--atlas-outline-message); }
.atlas-out--empty      { color: #94a3b8; font-style: italic; }

/* Error/warning highlighting on outline rows */
.atlas-out.has-error {
  border-left-color: var(--atlas-outline-end);
  background: rgba(220, 38, 38, 0.10);
}
.atlas-out.has-warning {
  border-left-color: var(--atlas-outline-decision);
  background: rgba(217, 119, 6, 0.08);
}
/* Brief flash when a user clicks an issue and we scroll to its row */
.atlas-out.is-flash {
  animation: atlas-out-flash 1200ms ease-out 1;
}
@keyframes atlas-out-flash {
  0%   { background: rgba(96, 165, 250, 0.45); }
  100% { background: transparent; }
}

.ai-gen-outline-legend {
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
  margin-top: 10px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
}
.ai-gen-outline-legend .atlas-out {
  padding: 0;
  gap: 4px;
}

/* Inline edit (textarea inside the outline container) */
.ai-gen-outline-textarea {
  width: 100%;
  min-height: 240px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
  line-height: 1.7;
  background: #0f1a2c;
  color: #e2e8f0;
  border: 1px solid var(--accent);
  border-radius: 6px;
  padding: 10px 12px;
  resize: vertical;
  outline: none;
}
.ai-gen-outline-textarea:focus { border-color: var(--accent-hover, var(--accent)); }

/* While editing, dim the legend a bit so it's clear the focus is the editor */
.ai-gen-outline.is-editing { padding: 0; background: transparent; border: none; }

/* Disable confirm button when validation has errors */
#ai-gen-confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* "Sugerir mejoras" button + spacer that pushes "Generar" to the right */
.ai-gen-modal__spacer { flex: 1; }
#ai-gen-suggest {
  background: rgba(96, 165, 250, 0.15);
  border-color: rgba(96, 165, 250, 0.4);
  color: #93c5fd;
}
#ai-gen-suggest:hover { background: rgba(96, 165, 250, 0.25); }
#ai-gen-suggest.is-loading,
#ai-gen-suggest:disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Suggestions panel — LLM proposals with per-row "Aplicar" button */
.ai-gen-suggestions {
  margin-top: 12px;
  padding: 10px 12px;
  background: rgba(15, 26, 44, 0.6);
  border: 1px dashed rgba(96, 165, 250, 0.45);
  border-radius: 8px;
  font-size: 12px;
}
.ai-gen-suggestions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(96, 165, 250, 0.18);
}
.ai-gen-suggestions__summary { color: #93c5fd; font-weight: 600; }
.ai-gen-suggestions__list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;
}
.ai-gen-suggestions__list li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px;
  border-radius: 6px;
  background: rgba(96, 165, 250, 0.06);
  margin-bottom: 6px;
  color: #e2e8f0;
}
.ai-gen-suggestions__list li:last-child { margin-bottom: 0; }
.ai-gen-suggestions__icon {
  flex: 0 0 auto;
  font-size: 16px;
  line-height: 1.2;
}
.ai-gen-suggestions__body { flex: 1; min-width: 0; }
.ai-gen-suggestions__line {
  display: inline-block;
  font-family: ui-monospace, monospace;
  font-size: 11px;
  color: #94a3b8;
  margin-right: 6px;
}
.ai-gen-suggestions__kind {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  background: rgba(96, 165, 250, 0.18);
  color: #93c5fd;
  margin-right: 6px;
}
.ai-gen-suggestions__diff {
  display: block;
  margin-top: 4px;
  font-family: ui-monospace, monospace;
  font-size: 11px;
  background: rgba(15, 26, 44, 0.85);
  border-radius: 4px;
  padding: 4px 6px;
  color: #cbd5e1;
  word-break: break-word;
}
.ai-gen-suggestions__diff .diff-before { color: #f87171; text-decoration: line-through; opacity: 0.85; }
.ai-gen-suggestions__diff .diff-after  { color: #4ade80; }
.ai-gen-suggestions__rationale {
  display: block;
  margin-top: 4px;
  font-style: italic;
  color: #94a3b8;
  font-size: 11px;
}
.ai-gen-suggestions__apply {
  flex: 0 0 auto;
  padding: 4px 10px;
  border-radius: 4px;
  background: rgba(96, 165, 250, 0.22);
  border: 1px solid rgba(96, 165, 250, 0.5);
  color: #bfdbfe;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.ai-gen-suggestions__apply:hover { background: rgba(96, 165, 250, 0.34); }
.ai-gen-suggestions__apply:disabled {
  opacity: 0.4;
  pointer-events: none;
}
.ai-gen-suggestions__list li.is-applied {
  opacity: 0.55;
  background: rgba(34, 197, 94, 0.08);
  border-left: 3px solid rgba(34, 197, 94, 0.5);
}
.ai-gen-suggestions--empty {
  color: #94a3b8;
  font-style: italic;
}

/* ────────────────────────────────────────────────────────────────────────── */
/*  DMN wizard ("Generar reglas")  ·  PR 4 of THEMIS_DMN_PLAN.md §4.3        */
/*                                                                            */
/*  Inherits .ai-gen-modal, .ai-gen-step, .ai-gen-modal__btn, .ai-gen-files,   */
/*  .ai-gen-dropzone from the BPMN wizard. Only DMN-specific bits live here.  */
/* ────────────────────────────────────────────────────────────────────────── */

.ai-dmn-gen-tabs {
  display: flex;
  gap: 4px;
  border-bottom: 1px solid var(--surface-border, #e5e7eb);
  margin: 0 0 12px;
  padding: 0;
}

.ai-dmn-gen-tab {
  appearance: none;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  color: var(--text-muted, #6b7280);
  cursor: pointer;
  font: inherit;
  padding: 8px 12px;
}

.ai-dmn-gen-tab:hover {
  color: var(--text-default, #1f2937);
}

.ai-dmn-gen-tab.is-active {
  color: var(--accent, #2563eb);
  border-bottom-color: currentColor;
}

.ai-dmn-gen-pane[hidden] { display: none; }

.ai-dmn-gen-pane textarea {
  width: 100%;
  box-sizing: border-box;
  font: inherit;
  padding: 8px;
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 4px;
  resize: vertical;
}

/* DRD overview (step 2) */

.ai-dmn-gen-drd {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.ai-dmn-gen-drd-section h4 {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-default, #1f2937);
}

.ai-dmn-gen-drd-section ul {
  margin: 0;
  padding-left: 18px;
  font-size: 12px;
  color: var(--text-default, #1f2937);
}

.ai-dmn-gen-drd-section li {
  margin: 2px 0;
}

.ai-dmn-gen-count {
  color: var(--text-muted, #6b7280);
  font-weight: 400;
  margin-left: 4px;
}

.ai-dmn-gen-empty {
  color: var(--text-muted, #6b7280);
  font-style: italic;
  font-size: 12px;
  margin: 0;
}

/* Table preview (step 3) */

.ai-dmn-gen-table {
  overflow-x: auto;
}

.ai-dmn-gen-hp {
  margin: 0 0 8px;
  font-size: 12px;
  color: var(--text-muted, #6b7280);
}

.ai-dmn-gen-table-preview {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.ai-dmn-gen-table-preview th,
.ai-dmn-gen-table-preview td {
  border: 1px solid var(--surface-border, #d1d5db);
  padding: 4px 8px;
  text-align: left;
  vertical-align: top;
}

.ai-dmn-gen-table-preview th {
  background: var(--surface-subtle, #f3f4f6);
  font-weight: 600;
}

.ai-dmn-gen-table-preview .ai-dmn-gen-col-in {
  background: rgba(37, 99, 235, 0.06);
}

.ai-dmn-gen-table-preview .ai-dmn-gen-col-out {
  background: rgba(22, 163, 74, 0.06);
}

.ai-dmn-gen-rule-num {
  text-align: center;
  width: 32px;
  color: var(--text-muted, #6b7280);
}

/* Scenarios (step 4) */

.ai-dmn-gen-scenarios {
  display: grid;
  gap: 10px;
}

.ai-dmn-gen-scenario {
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 4px;
  padding: 8px 10px;
  background: var(--surface-subtle, #f9fafb);
}

.ai-dmn-gen-scenario-name {
  font-weight: 600;
  margin-bottom: 4px;
}

.ai-dmn-gen-scenario-cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.ai-dmn-gen-scenario-cols h5 {
  margin: 0 0 2px;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted, #6b7280);
}

.ai-dmn-gen-scenario-cols pre {
  margin: 0;
  font-size: 11px;
  background: rgba(0, 0, 0, 0.04);
  padding: 4px 6px;
  border-radius: 3px;
  white-space: pre-wrap;
  word-break: break-word;
}

.ai-dmn-gen-runchk {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  font-size: 12px;
  color: var(--text-default, #1f2937);
  cursor: pointer;
}

/* ── Prose mode (Camino 2 — NaLa2BPMN editable prose for DSPy) ─────────────── */

.atlas-prose-mode {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  line-height: 1.65;
}

.atlas-prose-mode .atlas-pr {
  display: flex;
  gap: 8px;
  align-items: baseline;
  padding: 4px 8px;
  border-radius: 4px;
  border-left: 3px solid transparent;
  transition: background 120ms ease;
}
.atlas-prose-mode .atlas-pr:hover { background: rgba(148, 163, 184, 0.06); }

.atlas-pr__lineno {
  flex: 0 0 auto;
  text-align: right;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  color: #64748b;
  padding-right: 8px;
  border-right: 1px solid rgba(100, 116, 139, 0.25);
  user-select: none;
}
.atlas-pr__sym { flex: 0 0 16px; text-align: center; opacity: 0.7; }
.atlas-pr__text { flex: 1; color: #e2e8f0; }

/* Per-kind accent (left border + symbol colour) */
.atlas-pr--start    { border-left-color: var(--atlas-outline-start); }
.atlas-pr--start    .atlas-pr__sym { color: var(--atlas-outline-start); }
.atlas-pr--end      { border-left-color: var(--atlas-outline-end); }
.atlas-pr--end      .atlas-pr__sym { color: var(--atlas-outline-end); }
.atlas-pr--decision { border-left-color: var(--atlas-outline-decision); }
.atlas-pr--decision .atlas-pr__sym { color: var(--atlas-outline-decision); }
.atlas-pr--parallel { border-left-color: var(--atlas-outline-gateway); }
.atlas-pr--parallel .atlas-pr__sym { color: var(--atlas-outline-gateway); }
.atlas-pr--wait     { border-left-color: var(--atlas-outline-event); }
.atlas-pr--wait     .atlas-pr__sym { color: var(--atlas-outline-event); }
.atlas-pr--task     { border-left-color: var(--atlas-outline-task); }
.atlas-pr--task     .atlas-pr__sym { color: var(--atlas-outline-task); }

/* Inline tokens highlighted inside the sentence text */
.atlas-pr__actor {
  display: inline-block;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  background: rgba(37, 99, 235, 0.18);
  color: #93c5fd;
  margin: 0 1px;
  vertical-align: baseline;
}
.atlas-pr__kw {
  font-weight: 600;
  border-radius: 3px;
  padding: 0 3px;
}
.atlas-pr__kw--decision { color: var(--atlas-outline-decision); background: rgba(217, 119, 6, 0.12); }
.atlas-pr__kw--parallel { color: var(--atlas-outline-gateway); background: rgba(124, 58, 237, 0.12); }
.atlas-pr__kw--wait     { color: var(--atlas-outline-event);   background: rgba(8, 145, 178, 0.12); }
.atlas-pr__kw--start    { color: var(--atlas-outline-start);   background: rgba(22, 163, 74, 0.12); }
.atlas-pr__kw--end      { color: var(--atlas-outline-end);     background: rgba(220, 38, 38, 0.12); }

.atlas-pr.atlas-pr--empty {
  color: #64748b;
  font-style: italic;
  padding: 12px;
}

/* In prose mode (Camino 2 — DSPy), hide outline-only UI:
   - the typed-outline legend (prefixes don't apply to prose)
   - the "Sugerir mejoras" button (its endpoint targets typed-outline shape)
   The mode is set in JS via data-input-format on #ai-gen-step-preview. */
[data-input-format="prose"] .ai-gen-outline-legend,
[data-input-format="prose"] #ai-gen-suggest { display: none; }

/* ── Themis DMN wizard, two-phase editor (THEMIS_BACKEND_COMPLETION_PLAN B6) ── */

#ai-dmn-gen-modal .ai-gen-modal__box {
  max-width: 1100px;
}

.ai-dmn-gen-editor-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 14px;
  margin-top: 8px;
  min-height: 420px;
}

.ai-dmn-gen-editor-col,
.ai-dmn-gen-issues-col {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ai-dmn-gen-editor-label,
.ai-dmn-gen-issues-header {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.65;
  margin-bottom: 4px;
}

.ai-dmn-gen-outline-editor {
  flex: 1 1 auto;
  width: 100%;
  font-family: ui-monospace, "JetBrains Mono", "Fira Code", Menlo, Consolas, monospace;
  font-size: 12.5px;
  line-height: 1.55;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(15, 17, 25, 0.55);
  color: #e6e6f5;
  resize: vertical;
  tab-size: 2;
  white-space: pre;
}

.ai-dmn-gen-outline-editor:focus {
  outline: none;
  border-color: var(--themis-soft);
  box-shadow: 0 0 0 2px rgba(var(--themis-rgb), 0.22);
}

.ai-dmn-gen-issues {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  background: rgba(20, 22, 32, 0.45);
}

.ai-dmn-gen-issues-empty {
  margin: 6px 0;
  font-size: 12px;
  opacity: 0.55;
}

.ai-dmn-gen-issues-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ai-dmn-gen-issue {
  display: grid;
  grid-template-columns: auto auto 1fr;
  gap: 4px 8px;
  align-items: baseline;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12px;
  background: rgba(255, 255, 255, 0.03);
  border-left: 3px solid transparent;
}

.ai-dmn-gen-issue.is-error    { border-left-color: #ef4444; }
.ai-dmn-gen-issue.is-warning  { border-left-color: #eab308; }
.ai-dmn-gen-issue.is-info     { border-left-color: #38bdf8; }

.ai-dmn-gen-issue-icon { font-size: 13px; }

.ai-dmn-gen-issue-code {
  font-family: ui-monospace, monospace;
  font-size: 10.5px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.07);
  padding: 1px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.ai-dmn-gen-issue-msg {
  grid-column: 3 / 4;
  line-height: 1.4;
}

.ai-dmn-gen-issue-tip {
  grid-column: 1 / -1;
  font-size: 11.5px;
  opacity: 0.75;
  padding: 2px 4px 0 28px;
}

.ai-dmn-gen-run-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 13px;
  opacity: 0.85;
  cursor: pointer;
}

.ai-dmn-gen-run-toggle input[type="checkbox"] {
  accent-color: var(--themis);
}

/* ── Editor toolbar (Vista / Editar tabs) ─────────────────────────────── */

.ai-dmn-gen-editor-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.ai-dmn-gen-view-tabs {
  display: inline-flex;
  gap: 4px;
  background: rgba(255, 255, 255, 0.04);
  padding: 3px;
  border-radius: 6px;
}

.ai-dmn-gen-view-tab {
  appearance: none;
  border: 0;
  background: transparent;
  color: #d6d6e8;
  font-size: 11.5px;
  padding: 4px 10px;
  border-radius: 4px;
  cursor: pointer;
  letter-spacing: 0.02em;
  transition: background 0.15s, color 0.15s;
}

.ai-dmn-gen-view-tab:hover {
  background: rgba(255, 255, 255, 0.06);
}

.ai-dmn-gen-view-tab.is-active {
  background: var(--themis-bg);
  color: var(--themis-soft);
}

/* ── Rendered Markdown preview (step 2) ───────────────────────────────── */

.ai-dmn-gen-outline-preview {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(15, 17, 25, 0.55);
  color: #e6e6f5;
  font-family: ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  font-size: 13px;
  line-height: 1.55;
}

.ai-dmn-gen-outline-preview__empty {
  opacity: 0.55;
  font-style: italic;
}

/* Heading levels — Themis palette */
.ai-dmn-gen-outline-preview .md-h {
  font-weight: 700;
  margin: 12px 0 6px;
  color: var(--themis-soft);
  letter-spacing: 0.01em;
}
.ai-dmn-gen-outline-preview .md-h:first-child { margin-top: 0; }
.ai-dmn-gen-outline-preview .md-h1 { font-size: 16px; color: #d8d0f0; }
.ai-dmn-gen-outline-preview .md-h2 {
  font-size: 14.5px;
  color: var(--themis-soft);
  border-bottom: 1px solid var(--themis-border);
  padding-bottom: 3px;
}
.ai-dmn-gen-outline-preview .md-h3 { font-size: 13.5px; color: #b6abe0; }
.ai-dmn-gen-outline-preview .md-h4,
.ai-dmn-gen-outline-preview .md-h5,
.ai-dmn-gen-outline-preview .md-h6 { font-size: 13px; color: #a89cd1; }

/* Lists */
.ai-dmn-gen-outline-preview .md-li {
  position: relative;
  padding: 1px 0 1px 14px;
}
.ai-dmn-gen-outline-preview .md-bullet {
  color: #7b8aa8;
  margin-right: 4px;
}

/* Paragraphs / empties */
.ai-dmn-gen-outline-preview .md-p { margin: 2px 0; }
.ai-dmn-gen-outline-preview .md-empty { height: 6px; }

/* Tables */
.ai-dmn-gen-outline-preview .md-tr {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 8px;
  padding: 4px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 12.5px;
}
.ai-dmn-gen-outline-preview .md-tr--sep {
  border-bottom: 1px solid rgba(149, 92, 215, 0.4);
  padding: 0;
}
.ai-dmn-gen-outline-preview .md-td {
  white-space: pre-wrap;
  word-break: break-word;
}

/* Inline tokens (colours) */
.ai-dmn-gen-outline-preview .md-bold   { font-weight: 700; color: #ffd877; }
.ai-dmn-gen-outline-preview .md-italic { font-style: italic; color: #c8d2ee; }
.ai-dmn-gen-outline-preview .md-code {
  font-family: ui-monospace, "JetBrains Mono", "Fira Code", Menlo, Consolas, monospace;
  font-size: 11.8px;
  background: rgba(255, 255, 255, 0.07);
  padding: 1px 5px;
  border-radius: 3px;
  color: #ffb37a;
}
.ai-dmn-gen-outline-preview .md-key    { color: #6cc0ff; font-weight: 600; }
.ai-dmn-gen-outline-preview .md-string { color: #a8e6a8; }
.ai-dmn-gen-outline-preview .md-number { color: #f5a3ff; }
.ai-dmn-gen-outline-preview .md-bool   { color: #ff9b6b; font-weight: 600; }

/* Editor textarea is the same as before but no longer the only view */
.ai-dmn-gen-outline-editor[hidden] { display: none !important; }
.ai-dmn-gen-outline-preview[hidden] { display: none !important; }

/* "Arreglar errores" button — uses the warning palette */
#ai-dmn-gen-fix {
  border-color: rgba(234, 179, 8, 0.55);
  color: #f7e08c;
  background: rgba(234, 179, 8, 0.08);
}
#ai-dmn-gen-fix:hover:not(:disabled) {
  background: rgba(234, 179, 8, 0.18);
  color: #fff5b8;
}
#ai-dmn-gen-fix:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Themis identity overrides for the DMN modal only ─────────────────── */

#ai-dmn-gen-modal .ai-gen-modal__header {
  background: var(--themis);
}

#ai-dmn-gen-modal .ai-gen-modal__btn--primary {
  background: var(--themis);
  border-color: var(--themis);
  color: var(--themis-text);
}
#ai-dmn-gen-modal .ai-gen-modal__btn--primary:hover:not(:disabled) {
  background: var(--themis-hover);
  border-color: var(--themis-hover);
}

/* Step-1 description textarea — match the rest of the dark UI */
#ai-dmn-gen-input {
  width: 100%;
  box-sizing: border-box;
  background: rgba(15, 17, 25, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #e6e6f5;
  font-size: 13px;
  line-height: 1.6;
  padding: 10px 12px;
  resize: vertical;
  outline: none;
  font-family: inherit;
  transition: border-color 150ms, box-shadow 150ms;
}
#ai-dmn-gen-input::placeholder { color: rgba(230, 230, 245, 0.35); }
#ai-dmn-gen-input:focus {
  border-color: var(--themis-soft);
  box-shadow: 0 0 0 2px rgba(var(--themis-rgb), 0.22);
}

/* Long structured text — let the modal body scroll instead of pushing the
   footer off-screen. Constrains both the wizard step 1 (large pasted text)
   and step 2 (long outlines). */
#ai-dmn-gen-modal .ai-gen-modal__box {
  display: flex;
  flex-direction: column;
  max-height: 92vh;
}
#ai-dmn-gen-modal .ai-gen-step {
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: calc(92vh - 56px);   /* leave room for the header */
}
#ai-dmn-gen-modal .ai-gen-step[hidden] { display: none; }
#ai-dmn-gen-modal .ai-gen-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
}

/* Editor pane: keep the preview/editor inside their column, allow them to
   scroll instead of growing without bound. */
.ai-dmn-gen-editor-grid { max-height: 60vh; }
.ai-dmn-gen-outline-preview { max-height: 60vh; }
.ai-dmn-gen-outline-editor  { max-height: 60vh; }

/* Long unbroken tokens (URLs, IDs) inside the preview shouldn't force a
   horizontal scrollbar — wrap them. */
.ai-dmn-gen-outline-preview .md-p,
.ai-dmn-gen-outline-preview .md-li,
.ai-dmn-gen-outline-preview .md-td {
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* ── Friendly preview (narrative for non-technical users) ──────────────── */

.ai-dmn-gen-outline-friendly {
  flex: 1 1 auto;
  min-height: 220px;
  max-height: 60vh;
  overflow-y: auto;
  background: #1a2438;
  border: 1px solid #2a3550;
  border-radius: 6px;
  padding: 12px 14px;
  color: #d8e1f3;
  line-height: 1.55;
}

.dmn-fp__empty {
  padding: 24px;
  text-align: center;
  color: #6b7a98;
  font-style: italic;
}

.dmn-fp__title {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #ffd877;
  border-bottom: 1px solid #2a3550;
  padding-bottom: 8px;
}

.dmn-fp__section + .dmn-fp__section { margin-top: 18px; }

.dmn-fp__h {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #b6abe0;
  margin: 0 0 8px 0;
}

.dmn-fp__inputs-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dmn-fp__input {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 4px 0;
  border-bottom: 1px dashed #2a3550;
}

.dmn-fp__input:last-child { border-bottom: none; }
.dmn-fp__input-name { font-weight: 600; color: #6cc0ff; }
.dmn-fp__input-type { color: #9aa6c4; font-size: 12.5px; }

.dmn-fp__decision {
  margin-top: 14px;
  padding: 10px 12px;
  background: #16213a;
  border: 1px solid #2c3855;
  border-radius: 6px;
}

.dmn-fp__decision-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.dmn-fp__step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px; height: 22px;
  border-radius: 50%;
  background: #3a5fcd;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.dmn-fp__decision-title {
  margin: 0;
  font-size: 14px;
  color: #ffd877;
}

.dmn-fp__decision-desc {
  margin: 0 0 8px 0;
  color: #9aa6c4;
  font-style: italic;
  font-size: 12.5px;
}

.dmn-fp__returns {
  margin: 4px 0 8px 0;
  color: #c8d2ee;
  font-size: 12.5px;
}

.dmn-fp__rules-intro,
.dmn-fp__formula-intro {
  margin: 8px 0 4px 0;
  color: #9aa6c4;
  font-size: 12.5px;
}

.dmn-fp__rules {
  list-style: none;
  margin: 0;
  padding: 0;
  counter-reset: dmn-fp-rule;
}

.dmn-fp__rule {
  display: flex;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
}

.dmn-fp__rule + .dmn-fp__rule { margin-top: 2px; }
.dmn-fp__rule:hover { background: rgba(108, 192, 255, 0.06); }

.dmn-fp__rule.is-fallback {
  background: rgba(245, 163, 255, 0.06);
  border-left: 2px solid #c878d8;
  padding-left: 6px;
}

.dmn-fp__rule-num {
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: #6cc0ff;
  min-width: 22px;
}

.dmn-fp__rule-body {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  align-items: baseline;
}

.dmn-fp__rule-if,
.dmn-fp__rule-and {
  text-transform: lowercase;
  color: #9aa6c4;
  font-style: italic;
}

.dmn-fp__rule-arrow { color: #6cc0ff; font-weight: 700; }
.dmn-fp__rule-outcome { color: #a8e6a8; font-weight: 600; }
.dmn-fp__rule-fallback { color: #c878d8; font-style: italic; }
.dmn-fp__rule-note { color: #9aa6c4; font-size: 12px; font-style: italic; }
.dmn-fp__any { color: #6b7a98; font-style: italic; font-size: 12px; }

.dmn-fp__expr {
  background: rgba(245, 163, 255, 0.10);
  color: #f5a3ff;
  padding: 1px 5px;
  border-radius: 3px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
}

.dmn-fp__formula {
  margin: 4px 0 0 0;
  padding: 8px 10px;
  background: #0f1830;
  border: 1px solid #2a3550;
  border-radius: 4px;
  color: #f5a3ff;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  white-space: pre-wrap;
}

.dmn-fp__context,
.dmn-fp__list {
  list-style: none;
  margin: 4px 0 0 0;
  padding: 0;
}

.dmn-fp__context li,
.dmn-fp__list li {
  padding: 2px 0;
}

.dmn-fp__uses {
  margin: 8px 0 0 0;
  padding-top: 6px;
  border-top: 1px dashed #2a3550;
  color: #9aa6c4;
  font-size: 12px;
}

.dmn-fp__uses em { color: #6cc0ff; font-style: normal; font-weight: 600; }

/* Scenarios */
.dmn-fp__scenarios { list-style: none; margin: 0; padding: 0; }

.dmn-fp__scenario {
  padding: 6px 8px;
  border-left: 2px solid #3a5fcd;
  background: rgba(58, 95, 205, 0.08);
  border-radius: 0 4px 4px 0;
  margin-bottom: 6px;
}

.dmn-fp__scenario-title { margin: 0 0 2px 0; color: #ffd877; }
.dmn-fp__scenario-given,
.dmn-fp__scenario-expected { margin: 2px 0; color: #c8d2ee; font-size: 12.5px; }
.dmn-fp__scenario em { color: #6cc0ff; font-style: normal; font-weight: 600; }

.dmn-fp em {
  color: #ffd877;
  font-style: italic;
}

/* ── Issues — funcional/técnica view toggle ─────────────────────────────── */

.ai-dmn-gen-issues-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
}

.ai-dmn-gen-issues-tabs {
  display: inline-flex;
  background: #1a2438;
  border: 1px solid #2a3550;
  border-radius: 4px;
  padding: 2px;
}

.ai-dmn-gen-issues-tab {
  padding: 3px 8px;
  background: transparent;
  border: 0;
  border-radius: 3px;
  color: #9aa6c4;
  font-size: 11.5px;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
}

.ai-dmn-gen-issues-tab:hover { color: #d8e1f3; }
.ai-dmn-gen-issues-tab.is-active {
  background: #3a5fcd;
  color: #fff;
  font-weight: 600;
}

.ai-dmn-gen-issues-group {
  margin-bottom: 12px;
  background: #16213a;
  border: 1px solid #2c3855;
  border-radius: 6px;
  overflow: hidden;
}

.ai-dmn-gen-issues-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  background: #1a2438;
  border-bottom: 1px solid #2c3855;
}

.ai-dmn-gen-issues-group__title { font-weight: 700; color: #ffd877; font-size: 12.5px; }
.ai-dmn-gen-issues-group__count { color: #9aa6c4; font-size: 11.5px; }

.ai-dmn-gen-issues-group .ai-dmn-gen-issues-list {
  margin: 0;
  padding: 6px 10px;
}

.ai-dmn-gen-issue-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ai-dmn-gen-issue-title {
  margin: 0;
  color: #d8e1f3;
  font-size: 12.5px;
}

.ai-dmn-gen-issue-body {
  margin: 0;
  color: #9aa6c4;
  font-size: 12px;
  font-style: italic;
}

.ai-dmn-gen-issues-hidden-note {
  margin: 8px 0 0 0;
  padding-top: 6px;
  border-top: 1px dashed #2a3550;
  color: #6b7a98;
  font-size: 11.5px;
}

.ai-dmn-gen-issues-tech-link {
  background: transparent;
  border: 0;
  color: #6cc0ff;
  cursor: pointer;
  padding: 0;
  font: inherit;
  text-decoration: underline;
}

.ai-dmn-gen-issues-tech-link:hover { color: #88cfff; }

/* ── Apply confirm overlay ──────────────────────────────────────────────── */

.ai-dmn-gen-apply-confirm {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-dmn-gen-apply-confirm[hidden] { display: none; }

.ai-dmn-gen-apply-confirm__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(8, 14, 28, 0.7);
}

.ai-dmn-gen-apply-confirm__box {
  position: relative;
  background: #1a2438;
  border: 1px solid #2c3855;
  border-radius: 8px;
  padding: 18px 22px;
  width: min(520px, 90%);
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
}

.ai-dmn-gen-apply-confirm__box h4 {
  margin: 0 0 12px 0;
  font-size: 15px;
  color: #ffd877;
}

.ai-dmn-gen-apply-confirm__lead {
  margin: 0 0 8px 0;
  color: #c8d2ee;
  font-size: 13px;
}

.ai-dmn-gen-apply-confirm__list {
  margin: 6px 0 12px 0;
  padding-left: 18px;
  color: #d8e1f3;
  font-size: 12.5px;
}

.ai-dmn-gen-apply-confirm__list li { margin: 3px 0; }

.ai-dmn-gen-apply-confirm__hidden {
  margin: 6px 0 0 0;
  color: #9aa6c4;
  font-size: 11.5px;
  font-style: italic;
}

.ai-dmn-gen-apply-confirm__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
}

/* The wizard box already has position:relative — the confirm overlay uses it
   as its positioning context (declared higher up in this file). */
`, "",{"version":3,"sources":["webpack://./src/ai/ai-panel.css"],"names":[],"mappings":"AAAA;;;;gFAIgF;;AAEhF,8EAA8E;AAC9E;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,oBAAoB;AACtB;AACA,2DAA2D;AAC3D;EACE,YAAY;AACd;;AAEA;;;oEAGoE;AACpE;EACE,mBAAmB;AACrB;;AAEA;mDACmD;AACnD;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA,uBAAuB,cAAc,EAAE;;AAEvC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA,qCAAqC,aAAa,EAAE;;AAEpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yCAAyC;AAC3C;AACA,gBAAgB,cAAc,EAAE,mBAAmB,EAAE;AACrD;EACE,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;EACd,aAAa;EACb,sCAAsC;EACtC,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA,uBAAuB,UAAU,EAAE,cAAc,EAAE;;AAEnD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA,qBAAqB,oBAAoB,EAAE,uBAAuB,EAAE;;AAEpE,8EAA8E;AAC9E;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,cAAc;EACd,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wCAAwC,UAAU,EAAE;AACpD,8CAA8C,mBAAmB,EAAE,kBAAkB,EAAE;;AAEvF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,8EAA8E;AAC9E;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,4DAA4D;AAC5D;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8EAA8E;EAC9E,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2EAA2E;AAC3E;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,yCAAyC;EACzC,8CAA8C;EAC9C,8BAA8B;EAC9B,cAAc;EACd,0CAA0C;AAC5C;;AAEA,2EAA2E;AAC3E;EACE,8EAA8E;EAC9E,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,4CAA4C;EAC5C,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA,0EAA0E;AAC1E;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;;;;EAIE,eAAe;AACjB;AACA;;;;EAIE,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;;;;;;EAME,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;;;;EAME,kBAAkB;AACpB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2EAA2E;AAC3E;;;;EAIE,mCAAmC;EACnC,wCAAwC;EACxC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,+BAA+B,sBAAsB,EAAE;AACvD,+BAA+B,sBAAsB,EAAE;;AAEvD;EACE,gBAAgB,wBAAwB,EAAE,YAAY,EAAE;EACxD,gBAAgB,2BAA2B,EAAE,UAAU,EAAE;AAC3D;;AAEA,8EAA8E;AAC9E;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,8CAA8C;EAC9C,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gEAAgE;AAClE;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,qEAAqE;AACrE;EACE,YAAY,EAAE,wBAAwB;AACxC;;AAEA,kGAAkG;AAClG;EACE,WAAW;AACb;;;AAGA,+EAA+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,wBAAwB,aAAa,EAAE;;AAEvC;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,qCAAqC,IAAI;AAC9D;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA,6BAA6B,UAAU,EAAE;;AAEzC,+EAA+E;AAC/E,eAAe,cAAc,EAAE;AAC/B,uBAAuB,aAAa,EAAE;;AAEtC;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA,sBAAsB,2BAA2B,EAAE;AACnD,6BAA6B,cAAc,EAAE;;AAE7C,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,6DAA6D;AAC/D;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;AACA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA,8BAA8B,WAAW,EAAE,2DAA2D,KAAK;AAC3G,8BAA8B,WAAW,EAAE,8DAA8D,EAAE;AAC3G,8BAA8B,YAAY,EAAE,8DAA8D,EAAE;AAC5G,8BAA8B,WAAW,EAAE,8DAA8D,EAAE;AAC3G;EACE,OAAO,sBAAsB,EAAE,YAAY,EAAE;EAC7C,OAAO,oBAAoB,IAAI,UAAU,IAAI;AAC/C;AACA,4CAA4C,aAAa,EAAE;AAC3D,4CAA4C,aAAa,EAAE;AAC3D,+CAA+C,aAAa,EAAE;AAC9D,+CAA+C,aAAa,EAAE;;AAE9D,+EAA+E;AAC/E;EACE,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,uCAAuC;EACvC,cAAc;AAChB;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,4BAA4B;AAC9B;AACA,0CAA0C,mBAAmB,EAAE;;AAE/D;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;AACA,mDAAmD,+BAA+B,EAAE;AACpF;EACE,YAAY;EACZ,mBAAmB;AACrB;;;AAGA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,2CAA2C;EAC3C,8CAA8C;EAC9C,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,OAAO,mBAAmB,IAAI,YAAY,EAAE;EAC5C,OAAO,qBAAqB,EAAE,UAAU,IAAI;AAC9C;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,iCAAiC;AACjC;EACE,gDAAgD;EAChD,4CAA4C;EAC5C,gDAAgD;AAClD;;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,+EAA+E;AAC/E;EACE,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA,+BAA+B,yBAAyB,EAAE,kBAAkB,EAAE;;AAE9E;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;;+EAM+E;;AAE/E,uBAAuB;AACvB;mBACmB,mBAAmB,EAAE,QAAQ,EAAE;AAClD,kBAAkB,oBAAoB,EAAE;AACxC,mBAAmB,aAAa,EAAE;AAClC,8CAA8C,aAAa,EAAE;AAC7D,+CAA+C,oBAAoB,EAAE;;AAErE,qFAAqF;;AAErF,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,kCAAkC;AACpC;AACA,iDAAiD,yBAAyB,EAAE;;AAE5E,gEAAgE;AAChE,4CAA4C,sCAAsC,EAAE;AACpF;EACE,wCAAwC;AAC1C;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA,iDAAiD,oBAAoB,EAAE;;AAEvE,WAAW;AACX;EACE,+EAA+E;EAC/E,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,2CAA2C;EAC3C,qDAAqD;AACvD;;AAEA,gBAAgB;AAChB;EACE,+EAA+E;EAC/E,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA,kDAAkD;AAClD;;;EAGE,yBAAyB;AAC3B;AACA;;;;EAIE,4BAA4B;EAC5B,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;;;;EAIE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;AAC3B;AACA,uDAAuD,gCAAgC,EAAE;AACzF;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB,uEAAuE,2BAA2B,EAAE;AACpG,8CAA8C,2BAA2B,EAAE;AAC3E;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA,QAAQ;AACR;EACE,yBAAyB;EACzB,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,wEAAwE;AACxE,kDAAkD,gCAAgC,EAAE;;AAEpF;;;+EAG+E;;AAE/E;EACE,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;AACrC;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,0DAA0D;EAC1D,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;;EAEE,gCAAgC;EAChC,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA,sBAAsB,aAAa,EAAE;AACrC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,2CAA2C,+BAA+B,EAAE;AAC5E,8BAA8B,aAAa,EAAE;AAC7C;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,8EAA8E;AAC9E;EACE,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;AACnC;AACA,mBAAmB,qCAAqC,EAAE;AAC1D;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,qEAAqE;EACrE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,iDAAiD;EACjD,iBAAiB;AACnB;AACA,sCAAsC,cAAc,EAAE;AACtD;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;AACA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA,kBAAkB,WAAW,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;AAC1E;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,qCAAqC;AACvC;AACA,oBAAoB,OAAO,EAAE,cAAc,EAAE;AAC7C,oBAAoB,cAAc,EAAE,eAAe,EAAE;AACrD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,mBAAmB,oCAAoC,EAAE,gBAAgB,EAAE;AAC3E;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,oCAAoC,EAAE,cAAc,EAAE;AAC/E,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,mCAAmC,GAAG,cAAc,EAAE;AAC/E,yBAAyB,oCAAoC,EAAE,cAAc,EAAE;;AAE/E,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,+BAA+B,EAAE;AAC1D,yBAAyB,gCAAgC,EAAE;AAC3D,yBAAyB,oCAAoC,EAAE;AAC/D,yBAAyB,mCAAmC,EAAE;AAC9D,yBAAyB,iCAAiC,EAAE;AAC5D,yBAAyB,sCAAsC,EAAE;AACjE,yBAAyB,mCAAmC,EAAE;AAC9D,yBAAyB,cAAc,EAAE,kBAAkB,EAAE;;AAE7D,+CAA+C;AAC/C;EACE,2CAA2C;EAC3C,mCAAmC;AACrC;AACA;EACE,gDAAgD;EAChD,mCAAmC;AACrC;AACA,qEAAqE;AACrE;EACE,4CAA4C;AAC9C;AACA;EACE,OAAO,oCAAoC,EAAE;EAC7C,OAAO,uBAAuB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,iBAAiB;EACjB,qEAAqE;EACrE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA,iCAAiC,gDAAgD,EAAE;;AAEnF,8EAA8E;AAC9E,6BAA6B,UAAU,EAAE,uBAAuB,EAAE,YAAY,EAAE;;AAEhF,sDAAsD;AACtD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE,wBAAwB,OAAO,EAAE;AACjC;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;AACA,wBAAwB,oCAAoC,EAAE;AAC9D;;EAEE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;AACnD;AACA,+BAA+B,cAAc,EAAE,gBAAgB,EAAE;AACjE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;AACA,0CAA0C,gBAAgB,EAAE;AAC5D;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,4BAA4B,OAAO,EAAE,YAAY,EAAE;AACnD;EACE,qBAAqB;EACrB,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA,yCAAyC,cAAc,EAAE,6BAA6B,EAAE,aAAa,EAAE;AACvG,yCAAyC,cAAc,EAAE;AACzD;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mCAAmC,oCAAoC,EAAE;AACzE;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E,8EAA8E;AAC9E,+EAA+E;AAC/E,gFAAgF;AAChF,+EAA+E;AAC/E,+EAA+E;;AAE/E;EACE,aAAa;EACb,QAAQ;EACR,uDAAuD;EACvD,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA,2BAA2B,aAAa,EAAE;;AAE1C;EACE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA,2BAA2B;;AAE3B;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;AACnC;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA,iFAAiF;;AAEjF;EACE,iFAAiF;EACjF,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,iCAAiC;AACnC;AACA,oCAAoC,qCAAqC,EAAE;;AAE3E;EACE,cAAc;EACd,iBAAiB;EACjB,qEAAqE;EACrE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;AACnB;AACA,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,YAAY,EAAE;AACnE,kBAAkB,OAAO,EAAE,cAAc,EAAE;;AAE3C,kDAAkD;AAClD,sBAAsB,6CAA6C,EAAE;AACrE,qCAAqC,iCAAiC,EAAE;AACxE,sBAAsB,2CAA2C,EAAE;AACnE,qCAAqC,+BAA+B,EAAE;AACtE,sBAAsB,gDAAgD,EAAE;AACxE,qCAAqC,oCAAoC,EAAE;AAC3E,sBAAsB,+CAA+C,EAAE;AACvE,qCAAqC,mCAAmC,EAAE;AAC1E,sBAAsB,6CAA6C,EAAE;AACrE,qCAAqC,iCAAiC,EAAE;AACxE,sBAAsB,4CAA4C,EAAE;AACpE,qCAAqC,gCAAgC,EAAE;;AAEvE,uDAAuD;AACvD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,0BAA0B,oCAAoC,EAAE,mCAAmC,EAAE;AACrG,0BAA0B,mCAAmC,EAAE,oCAAoC,EAAE;AACrG,0BAA0B,iCAAiC,IAAI,mCAAmC,EAAE;AACpG,0BAA0B,iCAAiC,IAAI,mCAAmC,EAAE;AACpG,0BAA0B,+BAA+B,MAAM,mCAAmC,EAAE;;AAEpG;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;yEAGyE;AACzE;8CAC8C,aAAa,EAAE;;AAE7D,kFAAkF;;AAElF;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oFAAoF;EACpF,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,kCAAkC;AACpC;;AAEA,gCAAgC,0BAA0B,EAAE;AAC5D,gCAAgC,0BAA0B,EAAE;AAC5D,gCAAgC,0BAA0B,EAAE;;AAE5D,yBAAyB,eAAe,EAAE;;AAE1C;EACE,oCAAoC;EACpC,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,4EAA4E;;AAE5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,4EAA4E;;AAE5E;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,oFAAoF;EACpF,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,gDAAgD,aAAa,EAAE;AAC/D,qCAAqC,eAAe,EAAE,cAAc,EAAE;AACtE;EACE,iBAAiB;EACjB,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;AACA,qCAAqC,iBAAiB,EAAE,cAAc,EAAE;AACxE;;qCAEqC,eAAe,EAAE,cAAc,EAAE;;AAEtE,UAAU;AACV;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB,oCAAoC,aAAa,EAAE;AACnD,wCAAwC,WAAW,EAAE;;AAErD,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,QAAQ;EACR,gBAAgB;EAChB,kDAAkD;EAClD,iBAAiB;AACnB;AACA;EACE,gDAAgD;EAChD,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B,yCAAyC,gBAAgB,EAAE,cAAc,EAAE;AAC3E,yCAAyC,kBAAkB,EAAE,cAAc,EAAE;AAC7E;EACE,oFAAoF;EACpF,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA,yCAAyC,cAAc,EAAE,gBAAgB,EAAE;AAC3E,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE;AACzD,yCAAyC,cAAc,EAAE,gBAAgB,EAAE;;AAE3E,sEAAsE;AACtE,qCAAqC,wBAAwB,EAAE;AAC/D,sCAAsC,wBAAwB,EAAE;;AAEhE,yDAAyD;AACzD;EACE,qCAAqC;EACrC,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4EAA4E;;AAE5E;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,sBAAsB;EACtB,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,oBAAoB;EACpB,gDAAgD;AAClD;AACA,iCAAiC,gCAAgC,EAAE;AACnE;EACE,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;;gCAEgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6BAA6B,IAAI,8BAA8B;AACjE;AACA,yCAAyC,aAAa,EAAE;AACxD;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;6CAC6C;AAC7C,0BAA0B,gBAAgB,EAAE;AAC5C,8BAA8B,gBAAgB,EAAE;AAChD,8BAA8B,gBAAgB,EAAE;;AAEhD;sCACsC;AACtC;;;EAGE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,6EAA6E;;AAE7E;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,sCAAsC,gBAAgB,EAAE;;AAExD;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,sBAAsB,gBAAgB,EAAE,cAAc,EAAE;AACxD,sBAAsB,cAAc,EAAE,iBAAiB,EAAE;;AAEzD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,gCAAgC,eAAe,EAAE;AACjD,sBAAsB,qCAAqC,EAAE;;AAE7D;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D,yBAAyB,cAAc,EAAE,kBAAkB,EAAE;AAC7D,qBAAqB,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC1E,eAAe,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAEpE;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,2DAA2D;EAC3D,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEzE,cAAc;AACd,qBAAqB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAE9D;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,0BAA0B,iBAAiB,EAAE,cAAc,EAAE;AAC7D;6BAC6B,aAAa,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC/E,uBAAuB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE7E;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mDAAmD;AACrD;;AAEA,+BAA+B,cAAc,EAAE;AAC/C;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,kCAAkC,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACvF,kCAAkC,cAAc,EAAE,iBAAiB,EAAE;;AAErE;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,0BAA0B;AAC5B;;AAEA,qCAAqC,cAAc,EAAE;;AAErD,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,oCAAoC,aAAa,EAAE;;AAEnD;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,qCAAqC,aAAa,EAAE;;AAEpD;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;kEACkE","sourcesContent":["/* ── AI Assistant Panel ──────────────────────────────────────────────────────\n   Color palette: Atlas (mediterráneo) — tokens --accent / --accent-hover /\n   --accent-soft definidos en src/index.html :root.\n   Dark panel to contrast against the white BPMN canvas.\n   ─────────────────────────────────────────────────────────────────────────── */\n\n/* ── Panel container ────────────────────────────────────────────────────── */\n.ai-panel {\n  position: fixed;\n  top: 47px;\n  right: 0;\n  width: 360px;\n  height: calc(100vh - 71px);\n  background: #111c2e;\n  color: #e2e8f0;\n  font-size: 13px;\n  font-family: inherit;\n  display: flex;\n  flex-direction: column;\n  transform: translateX(100%);\n  transition: transform 250ms ease;\n  z-index: 800;\n  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.35);\n}\n\n.ai-panel.is-open {\n  transform: translateX(0);\n}\n\n/* Chat open + no selection → keep hidden */\nbody:has(#ai-panel.is-open) #properties.is-hidden {\n  right: -320px;\n  pointer-events: none;\n}\n/* Chat open + node selected → show beside the chat panel */\nbody:has(#ai-panel.is-open) #properties:not(.is-hidden) {\n  right: 360px;\n}\n\n/* Shrink only the DMN content (not the whole overlay) so the top bar keeps\n   its full width and its actions (Guardar, Importar XML…) don't shift when\n   the chat opens. Only applies to full mode — the popup modal doesn't\n   stretch to the chat panel and the dock mode relocates the chat. */\nbody:has(#ai-panel.is-open) #dmn-overlay.mode-full .dmn-overlay-content {\n  margin-right: 360px;\n}\n\n/* In full DMN mode the chat sits below the DMN top bar (44px) so the bar's\n   actions stay accessible above the chat header. */\nbody:has(#dmn-overlay.mode-full.show) .ai-panel {\n  top: 44px;\n  height: calc(100vh - 68px);\n}\n\n/* ── Header ─────────────────────────────────────────────────────────────── */\n.ai-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px;\n  background: #0d1b2e;\n  border-bottom: 1px solid #1e293b;\n  color: var(--accent-soft, #4A90B8);\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.ai-panel__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  letter-spacing: 0.02em;\n}\n\n.ai-panel__brand svg { flex-shrink: 0; }\n\n.ai-panel__header-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.ai-panel__header button {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 3px 6px;\n  border-radius: 4px;\n  font-size: 13px;\n  line-height: 1;\n  transition: color 150ms, background 150ms;\n}\n\n.ai-panel__header button:hover {\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.07);\n}\n\n/* ── Tabs bar ────────────────────────────────────────────────────────────── */\n.ai-panel__tabs {\n  display: flex;\n  align-items: stretch;\n  background: #0d1b2e;\n  border-bottom: 1px solid #2d3748;\n  overflow-x: auto;\n  flex-shrink: 0;\n  scrollbar-width: none;\n  min-height: 30px;\n}\n.ai-panel__tabs::-webkit-scrollbar { display: none; }\n\n.ai-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 5px 10px;\n  font-size: 11px;\n  font-family: inherit;\n  background: transparent;\n  border: none;\n  border-right: 1px solid #2d3748;\n  color: #718096;\n  cursor: pointer;\n  white-space: nowrap;\n  flex-shrink: 0;\n  max-width: 130px;\n  transition: color 150ms, background 150ms;\n}\n.ai-tab:hover { color: #e2e8f0; background: #0f2035; }\n.ai-tab.is-active {\n  color: #e2e8f0;\n  background: #111c2e;\n  border-bottom: 2px solid var(--accent);\n  margin-bottom: -1px;\n}\n\n.ai-tab__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 90px;\n}\n\n.ai-tab__close {\n  font-size: 14px;\n  line-height: 1;\n  flex-shrink: 0;\n  color: inherit;\n  opacity: 0.45;\n  transition: opacity 150ms, color 150ms;\n  cursor: pointer;\n  padding: 0 1px;\n  border-radius: 2px;\n}\n.ai-tab__close:hover { opacity: 1; color: #fc8181; }\n\n.ai-tab--new {\n  font-size: 16px;\n  padding: 3px 10px;\n  color: #64748b;\n  flex-shrink: 0;\n  margin-left: auto;\n  border-right: none;\n}\n.ai-tab--new:hover { color: var(--accent); background: transparent; }\n\n/* ── Context pill ───────────────────────────────────────────────────────── */\n.ai-panel__context {\n  padding: 7px 12px;\n  background: #16213e;\n  border-bottom: 1px solid #2d3748;\n  flex-shrink: 0;\n}\n\n.ai-context-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: #2d3748;\n  border-radius: 10px;\n  padding: 3px 10px;\n  font-size: 11px;\n  color: #94a3b8;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Scenario 2 — BPMN selection active */\n.ai-context-pill.is-selection {\n  background: #1e3a5f;\n  color: var(--accent-soft);\n  border: 1px solid rgba(44, 95, 141, 0.4);\n}\n\n/* Scenario 3 — DMN rules mode */\n.ai-context-pill.is-rules {\n  background: #0d2e2e;\n  color: #2dd4bf;\n  border: 1px solid rgba(14, 116, 144, 0.4);\n}\n\n/* Panel header stripe per mode */\n.ai-panel.is-mode-selection .ai-panel__header {\n  border-bottom: 2px solid var(--accent);\n}\n\n.ai-panel.is-mode-rules .ai-panel__header {\n  border-bottom: 2px solid #0e7490;\n}\n\n/* ── Selection list (multi-element lasso) ───────────────────────────────── */\n.ai-selection-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 6px;\n  max-height: 80px;\n  overflow-y: auto;\n}\n\n.ai-selection-list::-webkit-scrollbar { width: 3px; }\n.ai-selection-list::-webkit-scrollbar-thumb { background: #4a5568; border-radius: 2px; }\n\n.ai-sel-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  background: #1e2d40;\n  border: 1px solid #2d4a6a;\n  border-radius: 6px;\n  padding: 2px 7px;\n  font-size: 10px;\n  color: #90cdf4;\n  max-width: 140px;\n  overflow: hidden;\n}\n\n.ai-sel-item__type {\n  color: #4a90d9;\n  font-size: 9px;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.ai-sel-item__name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ── Messages area ──────────────────────────────────────────────────────── */\n.ai-panel__messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  scroll-behavior: smooth;\n}\n\n.ai-panel__messages::-webkit-scrollbar {\n  width: 4px;\n}\n.ai-panel__messages::-webkit-scrollbar-track {\n  background: transparent;\n}\n.ai-panel__messages::-webkit-scrollbar-thumb {\n  background: #4a5568;\n  border-radius: 4px;\n}\n\n/* ── Empty state ────────────────────────────────────────────────────────── */\n.ai-empty-state {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  text-align: center;\n  gap: 8px;\n  padding: 24px;\n  pointer-events: none;\n}\n\n.ai-empty-state p:first-child {\n  font-size: 28px;\n  margin: 0;\n}\n\n.ai-empty-state p:last-child {\n  font-size: 13px;\n  margin: 0;\n  color: #718096;\n}\n\n/* ── Message bubbles ────────────────────────────────────────────────────── */\n.ai-msg {\n  max-width: 92%;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n/* AI messages: row layout — avatar on left, body on right */\n.ai-msg.is-ai,\n.ai-msg.is-error {\n  align-self: flex-start;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  max-width: 96%;\n}\n\n.ai-msg.is-user {\n  align-self: flex-end;\n}\n\n/* Avatar circle */\n.ai-msg__avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-soft) 100%);\n  box-shadow: 0 2px 8px rgba(44, 95, 141, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  color: white;\n  flex-shrink: 0;\n  margin-top: 2px;\n  user-select: none;\n}\n\n/* Body wrapper inside AI row */\n.ai-msg__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n}\n\n/* Timestamp */\n.ai-msg__time {\n  font-size: 10px;\n  color: #64748b;\n  padding: 0 2px;\n  flex-shrink: 0;\n}\n.ai-msg.is-user .ai-msg__time {\n  text-align: right;\n}\n\n.ai-msg__bubble {\n  padding: 9px 13px;\n  border-radius: 12px;\n  line-height: 1.6;\n  word-break: break-word;\n}\n\n/* ── AI bubble: glassmorphism slate ──────────────────────────────────── */\n.ai-msg.is-ai .ai-msg__bubble {\n  background: rgba(30, 41, 59, 0.92);\n  backdrop-filter: blur(6px);\n  border: 1px solid rgba(44, 95, 141, 0.22);\n  border-left: 3px solid rgba(44, 95, 141, 0.55);\n  border-bottom-left-radius: 4px;\n  color: #e2e8f0;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n}\n\n/* ── User bubble: gradient ───────────────────────────────────────────── */\n.ai-msg.is-user .ai-msg__bubble {\n  background: linear-gradient(135deg, var(--accent) 0%, var(--accent-soft) 100%);\n  color: white;\n  border-bottom-right-radius: 4px;\n  white-space: pre-wrap;\n  box-shadow: 0 2px 10px rgba(44, 95, 141, 0.4);\n}\n\n/* ── System note (THEMIS_DMN_PLAN §4.6 — decision scope hand-off) ────── */\n.ai-msg.is-system {\n  display: flex;\n  justify-content: center;\n  margin: 8px 0;\n}\n.ai-msg.is-system .ai-msg__bubble--system {\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-soft, #a0aec0);\n  border: 1px dashed rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-style: italic;\n  max-width: 80%;\n  text-align: center;\n}\n\n/* ── Error bubble ────────────────────────────────────────────────────── */\n.ai-msg.is-error .ai-msg__bubble {\n  background: rgba(45, 21, 21, 0.9);\n  color: #fc8181;\n  border: 1px solid #742a2a;\n  border-left: 3px solid #e53e3e;\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 2px 8px rgba(229, 62, 62, 0.15);\n}\n\n/* ── Markdown: strong accent color ──────────────────────────────────── */\n.ai-msg.is-ai .ai-msg__bubble strong,\n.ai-msg.is-error .ai-msg__bubble strong {\n  color: var(--accent-soft);\n  font-weight: 600;\n}\n\n/* ── Markdown: paragraphs ────────────────────────────────────────────── */\n.ai-msg.is-ai .ai-msg__bubble p,\n.ai-msg.is-error .ai-msg__bubble p,\n.ai-issue__desc p,\n.ai-issue__suggestion p {\n  margin: 0 0 6px;\n}\n.ai-msg.is-ai .ai-msg__bubble p:last-child,\n.ai-msg.is-error .ai-msg__bubble p:last-child,\n.ai-issue__desc p:last-child,\n.ai-issue__suggestion p:last-child {\n  margin-bottom: 0;\n}\n\n/* ── Markdown: lists (ul + ol) ───────────────────────────────────────── */\n.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list,\n.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list,\n.ai-msg.is-error .ai-msg__bubble ul.ai-md-list,\n.ai-msg.is-error .ai-msg__bubble ol.ai-md-list,\n.ai-issue__desc ul.ai-md-list,\n.ai-issue__desc ol.ai-md-list {\n  margin: 4px 0 6px;\n  padding-left: 20px;\n}\n.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li,\n.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li,\n.ai-msg.is-error .ai-msg__bubble ul.ai-md-list li,\n.ai-msg.is-error .ai-msg__bubble ol.ai-md-list li,\n.ai-issue__desc ul.ai-md-list li,\n.ai-issue__desc ol.ai-md-list li {\n  margin-bottom: 4px;\n}\n.ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li::marker,\n.ai-msg.is-error .ai-msg__bubble ul.ai-md-list li::marker {\n  color: var(--accent-soft);\n}\n.ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li::marker,\n.ai-msg.is-error .ai-msg__bubble ol.ai-md-list li::marker {\n  color: var(--accent-soft);\n  font-weight: 700;\n}\n\n/* ── Markdown: inline code ───────────────────────────────────────────── */\n.ai-msg.is-ai .ai-msg__bubble code,\n.ai-msg.is-error .ai-msg__bubble code,\n.ai-issue__desc code,\n.ai-issue__suggestion code {\n  background: rgba(44, 95, 141, 0.15);\n  border: 1px solid rgba(44, 95, 141, 0.3);\n  color: var(--accent-soft);\n  padding: 1px 5px;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 11px;\n}\n\n/* ── Inline action buttons inside AI bubble ─────────────────────────────── */\n.ai-msg__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.ai-msg__action-btn {\n  font-size: 11px;\n  padding: 4px 9px;\n  border-radius: 6px;\n  border: 1px solid #4a5568;\n  background: transparent;\n  color: #a0aec0;\n  cursor: pointer;\n  transition: all 150ms;\n  font-family: inherit;\n}\n\n.ai-msg__action-btn:hover {\n  background: #374151;\n  color: #e2e8f0;\n  border-color: #6b7280;\n}\n\n.ai-msg__action-btn.is-primary {\n  background: var(--accent);\n  color: white;\n  border-color: var(--accent);\n}\n\n.ai-msg__action-btn.is-primary:hover {\n  background: var(--accent-hover);\n  border-color: var(--accent-hover);\n}\n\n.ai-msg__action-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.ai-msg__action-btn.is-applied {\n  background: #166534;\n  border-color: #166534;\n  color: #86efac;\n  opacity: 1;\n}\n\n.ai-msg__action-btn.is-dismissed {\n  background: transparent;\n  border-color: #374151;\n  color: #4b5563;\n  opacity: 1;\n  text-decoration: line-through;\n}\n\n/* ── Suggestion option pills ─────────────────────────────────────────────── */\n.ai-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.ai-suggestion-btn {\n  font-size: 12px;\n  padding: 5px 11px;\n  border-radius: 14px;\n  border: 1px solid #4a5568;\n  background: #1e293b;\n  color: #cbd5e1;\n  cursor: pointer;\n  transition: all 150ms;\n  font-family: inherit;\n  line-height: 1.3;\n}\n\n.ai-suggestion-btn:hover {\n  background: #334155;\n  color: #f1f5f9;\n  border-color: #60a5fa;\n}\n\n.ai-suggestion-btn.is-selected {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: white;\n}\n\n.ai-suggestion-btn:disabled {\n  cursor: not-allowed;\n}\n\n.ai-suggestion-btn:disabled:not(.is-selected) {\n  opacity: 0.3;\n}\n\n/* ── Loading bubble (typing indicator) ─────────────────────────────────── */\n.ai-msg.is-loading .ai-msg__bubble {\n  padding: 10px 14px;\n}\n\n.ai-typing {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n}\n\n.ai-typing__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #718096;\n  animation: ai-bounce 1s infinite;\n}\n\n.ai-typing__dot:nth-child(2) { animation-delay: 0.15s; }\n.ai-typing__dot:nth-child(3) { animation-delay: 0.30s; }\n\n@keyframes ai-bounce {\n  0%, 80%, 100% { transform: translateY(0); opacity: 0.6; }\n  40%           { transform: translateY(-5px); opacity: 1; }\n}\n\n/* ── Chips ──────────────────────────────────────────────────────────────── */\n.ai-panel__chips {\n  padding: 8px 12px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  border-top: 1px solid #2d3748;\n  flex-shrink: 0;\n  min-height: 40px;\n}\n\n.ai-chip {\n  font-size: 11px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  border: 1px solid #4a5568;\n  background: #2d3748;\n  color: #cbd5e0;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 150ms;\n  font-family: inherit;\n  line-height: 1.4;\n}\n\n.ai-chip:hover {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: white;\n}\n\n/* ── Input area ─────────────────────────────────────────────────────────── */\n.ai-panel__input-area {\n  padding: 10px 12px;\n  border-top: 1px solid #2d3748;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.ai-include-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: #718096;\n  cursor: pointer;\n  user-select: none;\n}\n\n.ai-include-label input[type=\"checkbox\"] {\n  accent-color: var(--accent);\n  width: 12px;\n  height: 12px;\n  cursor: pointer;\n}\n\n.ai-input-row {\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n#ai-input {\n  flex: 1;\n  background: #2d3748;\n  border: 1px solid #4a5568;\n  border-radius: 8px;\n  color: #e2e8f0;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  transition: border-color 150ms;\n  line-height: 1.5;\n}\n\n#ai-input:focus {\n  border-color: var(--accent);\n}\n\n#ai-input::placeholder {\n  color: #64748b;\n}\n\n.ai-send-btn {\n  background: var(--accent);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  font-size: 16px;\n  transition: background 150ms;\n}\n\n.ai-send-btn:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.ai-send-btn:disabled {\n  background: #374151;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n/* ── FAB ────────────────────────────────────────────────────────────────── */\n.ai-fab {\n  position: fixed;\n  bottom: 40px;\n  right: 16px;\n  z-index: 900;\n  background: var(--accent, #2C5F8D);\n  color: #fff;\n  border: none;\n  border-radius: 22px;\n  height: 40px;\n  padding: 0 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  box-shadow: 0 4px 14px rgba(44, 95, 141, 0.45);\n  cursor: pointer;\n  font-size: 13px;\n  font-family: inherit;\n  font-weight: 600;\n  transition: right 250ms ease, background 200ms, box-shadow 200ms;\n}\n\n.ai-fab:hover {\n  background: var(--accent-hover, #1E4A70);\n  color: #fff;\n  box-shadow: 0 6px 18px rgba(44, 95, 141, 0.55);\n}\n\n.ai-fab__label {\n  max-width: 0;\n  margin-left: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: max-width 200ms ease, margin-left 200ms ease;\n}\n\n.ai-fab:hover .ai-fab__label {\n  max-width: 80px;\n  margin-left: 7px;\n}\n\n.ai-fab.is-hidden {\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 150ms;\n}\n\n/* Shift AI FAB left when properties panel is open (chat is closed) */\nbody:has(#properties:not(.is-hidden)):not(:has(#ai-panel.is-open)) .ai-fab {\n  right: 336px; /* 320 props + 16 base */\n}\n\n/* Reset FAB to default when DMN overlay is open (properties panel is hidden behind the overlay) */\nbody:has(#dmn-overlay.show):not(:has(#ai-panel.is-open)) .ai-fab {\n  right: 16px;\n}\n\n\n/* ── Generate process modal ──────────────────────────────────────────────── */\n.ai-gen-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ai-gen-modal[hidden] { display: none; }\n\n.ai-gen-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(2px);\n}\n\n.ai-gen-modal__box {\n  position: relative;\n  width: 680px;\n  max-width: 94vw;\n  background: #111c2e;\n  border: 1px solid #1e3a5f;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.5);\n  overflow: hidden;\n  transition: width 220ms ease;\n  animation: ai-modal-in 180ms ease;\n}\n.ai-gen-modal__box.is-wide {\n  width: 860px;\n}\n@keyframes ai-modal-in {\n  from { opacity: 0; transform: translateY(-12px) scale(.97); }\n  to   { opacity: 1; transform: translateY(0)     scale(1);   }\n}\n\n.ai-gen-modal__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  background: var(--accent);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ai-gen-modal__close {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 16px;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n  opacity: .8;\n  transition: opacity 150ms;\n}\n.ai-gen-modal__close:hover { opacity: 1; }\n\n/* ── Steps (wizard panels) ───────────────────────────────────────────────── */\n.ai-gen-step { display: block; }\n.ai-gen-step[hidden] { display: none; }\n\n.ai-gen-modal__body {\n  padding: 18px 18px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ai-gen-modal__hint {\n  margin: 0;\n  font-size: 12px;\n  color: #a0aec0;\n}\n\n/* Textarea in step 1 */\n#ai-gen-input {\n  width: 100%;\n  box-sizing: border-box;\n  background: #2d3748;\n  border: 1px solid #4a5568;\n  border-radius: 8px;\n  color: #e2e8f0;\n  font-size: 13px;\n  line-height: 1.6;\n  padding: 10px 12px;\n  resize: vertical;\n  outline: none;\n  transition: border-color 150ms;\n  font-family: inherit;\n}\n#ai-gen-input:focus { border-color: var(--accent); }\n#ai-gen-input::placeholder { color: #64748b; }\n\n/* ── Mic button — prominent, full-width row ──────────────────────────────── */\n.ai-gen-mic-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  width: 100%;\n  padding: 9px 14px;\n  background: #2d3748;\n  border: 1px dashed #4a5568;\n  border-radius: 8px;\n  color: #a0aec0;\n  font-size: 13px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms, color 150ms;\n}\n.ai-gen-mic-btn:hover:not(:disabled) {\n  background: #374151;\n  border-color: #718096;\n  color: #e2e8f0;\n}\n.ai-gen-mic-btn.is-recording {\n  background: #2d1515;\n  border-color: #ef4444;\n  border-style: solid;\n  color: #fc8181;\n}\n.ai-gen-mic-btn.is-transcribing {\n  background: #0f1f3d;\n  border-color: #3b82f6;\n  border-style: solid;\n  color: var(--accent-soft);\n}\n.ai-gen-mic-btn:disabled:not(.is-transcribing) {\n  opacity: .35;\n  cursor: not-allowed;\n}\n.ai-gen-mic-btn.is-transcribing {\n  cursor: default;\n}\n\n/* ── Waveform bars (shown when recording) ──────────────────────────────── */\n.ai-mic-bars {\n  display: none;\n  align-items: flex-end;\n  gap: 3px;\n  height: 16px;\n}\n.ai-mic-bars i {\n  display: block;\n  width: 3px;\n  background: currentColor;\n  border-radius: 2px;\n  transform-origin: bottom;\n}\n.ai-mic-bars i:nth-child(1) { height: 40%; animation: sound-bar 0.7s ease-in-out infinite alternate 0s;    }\n.ai-mic-bars i:nth-child(2) { height: 80%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.15s; }\n.ai-mic-bars i:nth-child(3) { height: 100%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.05s; }\n.ai-mic-bars i:nth-child(4) { height: 55%; animation: sound-bar 0.7s ease-in-out infinite alternate 0.25s; }\n@keyframes sound-bar {\n  0%   { transform: scaleY(0.2); opacity: 0.6; }\n  100% { transform: scaleY(1);   opacity: 1;   }\n}\n.ai-gen-mic-btn.is-recording .ai-mic-bars { display: flex; }\n.ai-gen-mic-btn.is-recording .ai-mic-icon { display: none; }\n.ai-gen-mic-btn.is-transcribing .ai-mic-icon { display: none; }\n.ai-gen-mic-btn.is-transcribing .ai-mic-bars { display: none; }\n\n/* ── Steps list (preview step) ───────────────────────────────────────────── */\n.ai-gen-steps-list {\n  margin: 0;\n  padding-left: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-height: 340px;\n  overflow-y: auto;\n}\n.ai-gen-steps-list li {\n  font-size: 13px;\n  color: #e2e8f0;\n  line-height: 1.6;\n  padding: 4px 0;\n  border-bottom: 1px solid #2d3748;\n}\n.ai-gen-steps-list li:last-child {\n  border-bottom: none;\n}\n\n/* ── Description block (preview step) ───────────────────────────────────── */\n.ai-gen-description {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: #a0aec0;\n  line-height: 1.6;\n  padding: 10px 12px;\n  background: #16213e;\n  border-radius: 8px;\n  border-left: 3px solid var(--accent);\n  font-style: italic;\n}\n\n/* ── Loading step ────────────────────────────────────────────────────────── */\n.ai-gen-loading-body {\n  align-items: center;\n  justify-content: center;\n  padding: 36px 18px;\n  gap: 14px;\n  text-align: center;\n  min-height: 160px;\n}\n\n.ai-gen-spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid #2d3748;\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: ai-spin 0.8s linear infinite;\n  flex-shrink: 0;\n}\n@keyframes ai-spin {\n  to { transform: rotate(360deg); }\n}\n\n.ai-gen-loading-label {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #e2e8f0;\n  transition: opacity 300ms ease;\n}\n\n.ai-gen-loading-label.is-fading {\n  opacity: 0;\n}\n\n.ai-gen-loading-hint {\n  margin: 0;\n  font-size: 11px;\n  color: #718096;\n}\n\n/* ── Result step ─────────────────────────────────────────────────────────── */\n.ai-gen-result-msg {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #68d391;\n}\n\n/* ── Footer ──────────────────────────────────────────────────────────────── */\n.ai-gen-modal__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 18px 16px;\n  border-top: 1px solid #2d3748;\n}\n\n.ai-gen-modal__btn {\n  padding: 7px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid #4a5568;\n  background: #2d3748;\n  color: #e2e8f0;\n  font-family: inherit;\n  transition: background 150ms;\n}\n.ai-gen-modal__btn:hover:not(:disabled) { background: #1e3a5f; }\n\n.ai-gen-modal__btn--primary {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n.ai-gen-modal__btn--primary:hover:not(:disabled) { background: var(--accent-hover); }\n.ai-gen-modal__btn--primary:disabled {\n  opacity: .45;\n  cursor: not-allowed;\n}\n\n\n/* ── Voice button in main input row ─────────────────────────────────────── */\n.ai-voice-btn {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #2d3748;\n  border: 1px solid #4a5568;\n  color: #718096;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  cursor: pointer;\n  transition: background 150ms, border-color 150ms, color 150ms;\n  line-height: 1;\n  overflow: visible;\n}\n.ai-voice-btn:hover:not(:disabled) {\n  background: #374151;\n  color: #e2e8f0;\n  border-color: #6b7280;\n}\n.ai-voice-btn:disabled:not(.is-transcribing) {\n  opacity: .3;\n  cursor: not-allowed;\n}\n\n/* Recording state — ripple rings */\n.ai-voice-btn.is-recording {\n  background: #7f1d1d;\n  border-color: #ef4444;\n  color: #fca5a5;\n}\n.ai-voice-btn.is-recording::before,\n.ai-voice-btn.is-recording::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 1.5px solid rgba(239, 68, 68, 0.75);\n  animation: voice-ripple 1.6s ease-out infinite;\n  pointer-events: none;\n}\n.ai-voice-btn.is-recording::after {\n  animation-delay: 0.8s;\n}\n@keyframes voice-ripple {\n  0%   { transform: scale(1);   opacity: 0.8; }\n  100% { transform: scale(2.6); opacity: 0;   }\n}\n\n/* Transcribing state — blue spinning ring */\n.ai-voice-btn.is-transcribing {\n  background: #1e3a5f;\n  border-color: #3b82f6;\n  color: var(--accent-soft);\n  cursor: default;\n}\n.ai-voice-btn.is-transcribing::before {\n  content: '';\n  position: absolute;\n  inset: -4px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  border-top-color: #60a5fa;\n  border-right-color: #60a5fa;\n  animation: voice-spin 0.75s linear infinite;\n  pointer-events: none;\n}\n@keyframes voice-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Textarea glow when listening */\n#ai-input.is-listening {\n  border-color: rgba(239, 68, 68, 0.55) !important;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);\n  transition: border-color 200ms, box-shadow 200ms;\n}\n\n/* ── Loading label inside bubble ─────────────────────────────────────────── */\n.ai-loading-label {\n  display: block;\n  font-size: 11px;\n  color: #a0aec0;\n  margin-bottom: 5px;\n  transition: opacity 300ms ease;\n}\n\n.ai-loading-label.is-fading {\n  opacity: 0;\n}\n\n/* ── Modal loading label (rotating contextual messages) ──────────────────── */\n.ai-gen-loading-label {\n  transition: opacity 300ms ease;\n}\n.ai-gen-loading-label.is-fading {\n  opacity: 0;\n}\n\n/* ── Steps list (describe response) ─────────────────────────────────────── */\n.ai-steps-intro {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #e2e8f0;\n}\n\n.ai-steps-list {\n  margin: 0 0 4px;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ai-steps-list li {\n  font-size: 12px;\n  color: #cbd5e0;\n  line-height: 1.55;\n}\n\n/* ── Issues list (validate response) ────────────────────────────────────── */\n.ai-issues-intro {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: #e2e8f0;\n}\n\n.ai-issues-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.ai-issue {\n  background: #1a1a2e;\n  border-left: 3px solid #e53e3e;\n  border-radius: 0 6px 6px 0;\n  padding: 7px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.ai-issue__header {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #fc8181;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ai-issue__element {\n  font-family: monospace;\n}\n\n.ai-issue__desc {\n  margin: 0;\n  font-size: 12px;\n  color: #e2e8f0;\n  line-height: 1.4;\n}\n.ai-issue__suggestion {\n  margin: 0;\n  font-size: 11px;\n  color: #a0aec0;\n  font-style: italic;\n  line-height: 1.4;\n}\n.ai-issue__suggestion strong { color: var(--accent-soft); font-style: normal; }\n\n.ai-issue .ai-msg__action-btn {\n  align-self: flex-start;\n  margin-top: 2px;\n  font-size: 10px;\n  padding: 3px 8px;\n}\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Themis context: when DMN overlay is open, the chat takes on Themis identity\n   (ocre dorado palette). All Atlas-blue accents flip to gold; brand text\n   swaps from \"⊕ Atlas\" to \"♎ Themis\".\n   Tokens (--themis, --themis-hover, --themis-soft, --themis-bg, --themis-border)\n   are defined in src/index.html :root.\n   ────────────────────────────────────────────────────────────────────────── */\n\n/* Brand swap helpers */\n.ai-brand-atlas,\n.ai-brand-themis { align-items: center; gap: 6px; }\n.ai-brand-atlas { display: inline-flex; }\n.ai-brand-themis { display: none; }\nbody:has(#dmn-overlay.show) .ai-brand-atlas { display: none; }\nbody:has(#dmn-overlay.show) .ai-brand-themis { display: inline-flex; }\n\n/* FAB icon inherits color from button (white on Atlas blue / black on Themis gold) */\n\n/* Header — only text/icon color changes; bg stays neutral */\nbody:has(#dmn-overlay.show) .ai-panel__header {\n  color: var(--themis-soft);\n}\n\n/* Tabs */\nbody:has(#dmn-overlay.show) .ai-tab.is-active {\n  border-bottom-color: var(--themis);\n}\nbody:has(#dmn-overlay.show) .ai-tab--new:hover { color: var(--themis-soft); }\n\n/* Mode stripes (rules-mode default also gets the brand color) */\n.ai-panel.is-mode-rules .ai-panel__header { border-bottom: 2px solid var(--themis); }\nbody:has(#dmn-overlay.show) .ai-panel.is-mode-selection .ai-panel__header {\n  border-bottom-color: var(--themis-hover);\n}\n\n/* Context pills */\nbody:has(#dmn-overlay.show) .ai-context-pill.is-selection {\n  background: var(--themis-bg);\n  color: var(--themis-soft);\n  border: 1px solid var(--themis-border);\n}\nbody:has(#dmn-overlay.show) .ai-context-pill.is-rules {\n  background: var(--themis-bg);\n  color: var(--themis-soft);\n  border: 1px solid var(--themis-border);\n}\n\n/* Selection list items */\nbody:has(#dmn-overlay.show) .ai-sel-item {\n  background: rgba(var(--themis-rgb), 0.10);\n  border-color: rgba(var(--themis-rgb), 0.35);\n  color: var(--themis-soft);\n}\nbody:has(#dmn-overlay.show) .ai-sel-item__type { color: var(--themis); }\n\n/* Avatar */\nbody:has(#dmn-overlay.show) .ai-msg__avatar {\n  background: linear-gradient(135deg, var(--themis-hover) 0%, var(--themis) 100%);\n  box-shadow: 0 2px 8px rgba(var(--themis-rgb), 0.45);\n  color: var(--themis-text);\n}\n\n/* AI bubble */\nbody:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble {\n  border-color: rgba(var(--themis-rgb), 0.28);\n  border-left-color: rgba(var(--themis-soft-rgb), 0.65);\n}\n\n/* User bubble */\nbody:has(#dmn-overlay.show) .ai-msg.is-user .ai-msg__bubble {\n  background: linear-gradient(135deg, var(--themis-hover) 0%, var(--themis) 100%);\n  color: var(--themis-text);\n  box-shadow: 0 2px 10px rgba(var(--themis-rgb), 0.4);\n}\n\n/* Markdown accents (strong, code, list markers) */\nbody:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble strong,\nbody:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble strong,\nbody:has(#dmn-overlay.show) .ai-issue__suggestion strong {\n  color: var(--themis-soft);\n}\nbody:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble code,\nbody:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble code,\nbody:has(#dmn-overlay.show) .ai-issue__desc code,\nbody:has(#dmn-overlay.show) .ai-issue__suggestion code {\n  background: var(--themis-bg);\n  border-color: var(--themis-border);\n  color: var(--themis-soft);\n}\nbody:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble ul.ai-md-list li::marker,\nbody:has(#dmn-overlay.show) .ai-msg.is-ai .ai-msg__bubble ol.ai-md-list li::marker,\nbody:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble ul.ai-md-list li::marker,\nbody:has(#dmn-overlay.show) .ai-msg.is-error .ai-msg__bubble ol.ai-md-list li::marker {\n  color: var(--themis-soft);\n}\n\n/* Action / suggestion / chip buttons */\nbody:has(#dmn-overlay.show) .ai-msg__action-btn.is-primary {\n  background: var(--themis);\n  border-color: var(--themis);\n  color: var(--themis-text);\n}\nbody:has(#dmn-overlay.show) .ai-msg__action-btn.is-primary:hover {\n  background: var(--themis-hover);\n  border-color: var(--themis-hover);\n  color: var(--themis-text);\n}\nbody:has(#dmn-overlay.show) .ai-suggestion-btn:hover { border-color: var(--themis-soft); }\nbody:has(#dmn-overlay.show) .ai-suggestion-btn.is-selected {\n  background: var(--themis);\n  border-color: var(--themis);\n  color: var(--themis-text);\n}\nbody:has(#dmn-overlay.show) .ai-chip:hover {\n  background: var(--themis);\n  border-color: var(--themis);\n  color: var(--themis-text);\n}\n\n/* Input + send */\nbody:has(#dmn-overlay.show) .ai-include-label input[type=\"checkbox\"] { accent-color: var(--themis); }\nbody:has(#dmn-overlay.show) #ai-input:focus { border-color: var(--themis); }\nbody:has(#dmn-overlay.show) .ai-send-btn {\n  background: var(--themis);\n  color: var(--themis-text);\n}\nbody:has(#dmn-overlay.show) .ai-send-btn:hover:not(:disabled) {\n  background: var(--themis-hover);\n  color: var(--themis-text);\n}\n\n/* FAB */\nbody:has(#dmn-overlay.show) .ai-fab {\n  background: var(--themis);\n  color: var(--themis-text);\n  box-shadow: 0 4px 14px rgba(var(--themis-rgb), 0.45);\n}\nbody:has(#dmn-overlay.show) .ai-fab:hover {\n  background: var(--themis-hover);\n  color: var(--themis-text);\n  box-shadow: 0 6px 18px rgba(var(--themis-rgb), 0.55);\n}\n\n/* Description block in modal (BPMN-only, but keep coherent if reused) */\nbody:has(#dmn-overlay.show) .ai-gen-description { border-left-color: var(--themis); }\n\n/* ──────────────────────────────────────────────────────────────────────────\n   Atlas — Generate process modal: PDF drop-zone + typed outline preview\n   See plans/actualizacion/ATLAS_BPMN_GENERATION_PLAN.md §3.1, §3.2, §3.3\n   ────────────────────────────────────────────────────────────────────────── */\n\n:root {\n  --atlas-outline-start:      #16a34a;\n  --atlas-outline-end:        #dc2626;\n  --atlas-outline-task:       #2563eb;\n  --atlas-outline-decision:   #d97706;\n  --atlas-outline-gateway:    #7c3aed;\n  --atlas-outline-event:      #0891b2;\n  --atlas-outline-subprocess: #475569;\n  --atlas-outline-message:    #db2777;\n  --atlas-bg-soft:            #16213e;\n  --atlas-border-soft:        #2d4366;\n}\n\n/* ── Drop-zone (paso 1) ─────────────────────────────────────────────────── */\n.ai-gen-dropzone {\n  margin-top: 12px;\n  border: 2px dashed var(--atlas-border-soft);\n  border-radius: 8px;\n  padding: 14px 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: background 120ms ease, border-color 120ms ease;\n  background: rgba(22, 33, 62, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.ai-gen-dropzone:hover,\n.ai-gen-dropzone:focus {\n  background: var(--atlas-bg-soft);\n  outline: none;\n  border-color: var(--accent);\n}\n.ai-gen-dropzone.is-dragging {\n  background: var(--atlas-bg-soft);\n  border-color: var(--accent);\n  border-style: solid;\n}\n.ai-gen-dropzone__label {\n  font-size: 13px;\n  color: #cbd5e1;\n  font-weight: 500;\n}\n.ai-gen-dropzone__hint {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.ai-gen-files {\n  list-style: none;\n  padding: 0;\n  margin: 8px 0 0;\n  font-size: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.ai-gen-files:empty { display: none; }\n.ai-gen-files li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #0f1a2c;\n  border: 1px solid #1e3a5f;\n  border-radius: 6px;\n  color: #cbd5e1;\n}\n.ai-gen-files .ai-gen-file__name {\n  flex: 1;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.ai-gen-files .ai-gen-file__meta {\n  color: #94a3b8;\n  font-size: 11px;\n}\n.ai-gen-files .ai-gen-file__remove {\n  background: transparent;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 4px;\n}\n.ai-gen-files .ai-gen-file__remove:hover { color: var(--atlas-outline-end); }\n.ai-gen-files li.is-loading { opacity: 0.65; }\n.ai-gen-files li.is-error {\n  border-color: var(--atlas-outline-end);\n  color: var(--atlas-outline-end);\n}\n\n/* ── Outline preview (paso 2) ───────────────────────────────────────────── */\n.ai-gen-outline {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 13px;\n  line-height: 1.7;\n  max-height: 320px;\n  overflow-y: auto;\n  padding: 12px;\n  background: var(--atlas-bg-soft);\n  border-radius: 8px;\n  border: 1px solid #1e3a5f;\n}\n\n.atlas-out {\n  display: flex;\n  gap: 6px;\n  align-items: baseline;\n  padding: 3px 6px;\n  flex-wrap: wrap;\n  position: relative;\n  border-radius: 4px;\n  border-left: 3px solid transparent;\n  transition: background 120ms ease;\n}\n.atlas-out:hover { background: rgba(148, 163, 184, 0.06); }\n.atlas-out__lineno {\n  flex: 0 0 auto;\n  display: inline-block;\n  text-align: right;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: #64748b;\n  padding-right: 8px;\n  margin-right: 4px;\n  border-right: 1px solid rgba(100, 116, 139, 0.25);\n  user-select: none;\n}\n.atlas-out:hover .atlas-out__lineno { color: #94a3b8; }\n.atlas-out.has-error .atlas-out__lineno {\n  color: var(--atlas-outline-end);\n  border-right-color: rgba(220, 38, 38, 0.5);\n}\n.atlas-out.has-warning .atlas-out__lineno {\n  color: var(--atlas-outline-decision);\n  border-right-color: rgba(217, 119, 6, 0.5);\n}\n.atlas-out__indent {\n  flex: 0 0 auto;\n  display: inline-block;\n}\n.atlas-out__sym { width: 14px; display: inline-block; text-align: center; }\n.atlas-out__prefix {\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  padding: 1px 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.06);\n}\n.atlas-out__label { flex: 1; color: #e2e8f0; }\n.atlas-out__actor { color: #cbd5e1; font-size: 12px; }\n.atlas-out__actor-pill {\n  display: inline-block;\n  padding: 1px 8px;\n  background: rgba(148, 163, 184, 0.18);\n  border-radius: 999px;\n  color: #cbd5e1;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n}\n.atlas-out__branch {\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 500;\n  padding-right: 4px;\n}\n.atlas-out__warn { color: var(--atlas-outline-decision); margin-left: 4px; }\n.atlas-out__issue {\n  margin-left: 4px;\n  cursor: help;\n  font-size: 12px;\n  line-height: 1;\n}\n\n/* Vertical guide rendered next to indented branch lines */\n.atlas-out__guide {\n  position: absolute;\n  left: 4px;\n  top: 0;\n  bottom: 0;\n  width: 2px;\n  background: rgba(148, 163, 184, 0.3);\n  border-radius: 2px;\n}\n\n/* Per-prefix tinting for the prefix pill */\n.tok-prefix-INICIO     { background: rgba(22, 163, 74, 0.22);  color: #4ade80; }\n.tok-prefix-FIN        { background: rgba(220, 38, 38, 0.22);  color: #f87171; }\n.tok-prefix-TAREA      { background: rgba(37, 99, 235, 0.22);  color: #60a5fa; }\n.tok-prefix-DECISION   { background: rgba(217, 119, 6, 0.22);  color: #fbbf24; }\n.tok-prefix-GATEWAY    { background: rgba(124, 58, 237, 0.22); color: #c4b5fd; }\n.tok-prefix-EVENTO     { background: rgba(8, 145, 178, 0.22);  color: #67e8f9; }\n.tok-prefix-SUBPROCESO { background: rgba(71, 85, 105, 0.32);  color: #cbd5e1; }\n.tok-prefix-MENSAJE    { background: rgba(219, 39, 119, 0.22); color: #f472b6; }\n\n.atlas-out--start      { color: var(--atlas-outline-start); }\n.atlas-out--end        { color: var(--atlas-outline-end); }\n.atlas-out--task       { color: var(--atlas-outline-task); }\n.atlas-out--decision   { color: var(--atlas-outline-decision); }\n.atlas-out--gateway    { color: var(--atlas-outline-gateway); }\n.atlas-out--event      { color: var(--atlas-outline-event); }\n.atlas-out--subprocess { color: var(--atlas-outline-subprocess); }\n.atlas-out--message    { color: var(--atlas-outline-message); }\n.atlas-out--empty      { color: #94a3b8; font-style: italic; }\n\n/* Error/warning highlighting on outline rows */\n.atlas-out.has-error {\n  border-left-color: var(--atlas-outline-end);\n  background: rgba(220, 38, 38, 0.10);\n}\n.atlas-out.has-warning {\n  border-left-color: var(--atlas-outline-decision);\n  background: rgba(217, 119, 6, 0.08);\n}\n/* Brief flash when a user clicks an issue and we scroll to its row */\n.atlas-out.is-flash {\n  animation: atlas-out-flash 1200ms ease-out 1;\n}\n@keyframes atlas-out-flash {\n  0%   { background: rgba(96, 165, 250, 0.45); }\n  100% { background: transparent; }\n}\n\n.ai-gen-outline-legend {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  margin-top: 10px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n}\n.ai-gen-outline-legend .atlas-out {\n  padding: 0;\n  gap: 4px;\n}\n\n/* Inline edit (textarea inside the outline container) */\n.ai-gen-outline-textarea {\n  width: 100%;\n  min-height: 240px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 13px;\n  line-height: 1.7;\n  background: #0f1a2c;\n  color: #e2e8f0;\n  border: 1px solid var(--accent);\n  border-radius: 6px;\n  padding: 10px 12px;\n  resize: vertical;\n  outline: none;\n}\n.ai-gen-outline-textarea:focus { border-color: var(--accent-hover, var(--accent)); }\n\n/* While editing, dim the legend a bit so it's clear the focus is the editor */\n.ai-gen-outline.is-editing { padding: 0; background: transparent; border: none; }\n\n/* Disable confirm button when validation has errors */\n#ai-gen-confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* \"Sugerir mejoras\" button + spacer that pushes \"Generar\" to the right */\n.ai-gen-modal__spacer { flex: 1; }\n#ai-gen-suggest {\n  background: rgba(96, 165, 250, 0.15);\n  border-color: rgba(96, 165, 250, 0.4);\n  color: #93c5fd;\n}\n#ai-gen-suggest:hover { background: rgba(96, 165, 250, 0.25); }\n#ai-gen-suggest.is-loading,\n#ai-gen-suggest:disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Suggestions panel — LLM proposals with per-row \"Aplicar\" button */\n.ai-gen-suggestions {\n  margin-top: 12px;\n  padding: 10px 12px;\n  background: rgba(15, 26, 44, 0.6);\n  border: 1px dashed rgba(96, 165, 250, 0.45);\n  border-radius: 8px;\n  font-size: 12px;\n}\n.ai-gen-suggestions__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid rgba(96, 165, 250, 0.18);\n}\n.ai-gen-suggestions__summary { color: #93c5fd; font-weight: 600; }\n.ai-gen-suggestions__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  max-height: 220px;\n  overflow-y: auto;\n}\n.ai-gen-suggestions__list li {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  padding: 8px;\n  border-radius: 6px;\n  background: rgba(96, 165, 250, 0.06);\n  margin-bottom: 6px;\n  color: #e2e8f0;\n}\n.ai-gen-suggestions__list li:last-child { margin-bottom: 0; }\n.ai-gen-suggestions__icon {\n  flex: 0 0 auto;\n  font-size: 16px;\n  line-height: 1.2;\n}\n.ai-gen-suggestions__body { flex: 1; min-width: 0; }\n.ai-gen-suggestions__line {\n  display: inline-block;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n  color: #94a3b8;\n  margin-right: 6px;\n}\n.ai-gen-suggestions__kind {\n  display: inline-block;\n  padding: 1px 8px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  background: rgba(96, 165, 250, 0.18);\n  color: #93c5fd;\n  margin-right: 6px;\n}\n.ai-gen-suggestions__diff {\n  display: block;\n  margin-top: 4px;\n  font-family: ui-monospace, monospace;\n  font-size: 11px;\n  background: rgba(15, 26, 44, 0.85);\n  border-radius: 4px;\n  padding: 4px 6px;\n  color: #cbd5e1;\n  word-break: break-word;\n}\n.ai-gen-suggestions__diff .diff-before { color: #f87171; text-decoration: line-through; opacity: 0.85; }\n.ai-gen-suggestions__diff .diff-after  { color: #4ade80; }\n.ai-gen-suggestions__rationale {\n  display: block;\n  margin-top: 4px;\n  font-style: italic;\n  color: #94a3b8;\n  font-size: 11px;\n}\n.ai-gen-suggestions__apply {\n  flex: 0 0 auto;\n  padding: 4px 10px;\n  border-radius: 4px;\n  background: rgba(96, 165, 250, 0.22);\n  border: 1px solid rgba(96, 165, 250, 0.5);\n  color: #bfdbfe;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.ai-gen-suggestions__apply:hover { background: rgba(96, 165, 250, 0.34); }\n.ai-gen-suggestions__apply:disabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n.ai-gen-suggestions__list li.is-applied {\n  opacity: 0.55;\n  background: rgba(34, 197, 94, 0.08);\n  border-left: 3px solid rgba(34, 197, 94, 0.5);\n}\n.ai-gen-suggestions--empty {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n/* ────────────────────────────────────────────────────────────────────────── */\n/*  DMN wizard (\"Generar reglas\")  ·  PR 4 of THEMIS_DMN_PLAN.md §4.3        */\n/*                                                                            */\n/*  Inherits .ai-gen-modal, .ai-gen-step, .ai-gen-modal__btn, .ai-gen-files,   */\n/*  .ai-gen-dropzone from the BPMN wizard. Only DMN-specific bits live here.  */\n/* ────────────────────────────────────────────────────────────────────────── */\n\n.ai-dmn-gen-tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--surface-border, #e5e7eb);\n  margin: 0 0 12px;\n  padding: 0;\n}\n\n.ai-dmn-gen-tab {\n  appearance: none;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  color: var(--text-muted, #6b7280);\n  cursor: pointer;\n  font: inherit;\n  padding: 8px 12px;\n}\n\n.ai-dmn-gen-tab:hover {\n  color: var(--text-default, #1f2937);\n}\n\n.ai-dmn-gen-tab.is-active {\n  color: var(--accent, #2563eb);\n  border-bottom-color: currentColor;\n}\n\n.ai-dmn-gen-pane[hidden] { display: none; }\n\n.ai-dmn-gen-pane textarea {\n  width: 100%;\n  box-sizing: border-box;\n  font: inherit;\n  padding: 8px;\n  border: 1px solid var(--surface-border, #d1d5db);\n  border-radius: 4px;\n  resize: vertical;\n}\n\n/* DRD overview (step 2) */\n\n.ai-dmn-gen-drd {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.ai-dmn-gen-drd-section h4 {\n  margin: 0 0 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-default, #1f2937);\n}\n\n.ai-dmn-gen-drd-section ul {\n  margin: 0;\n  padding-left: 18px;\n  font-size: 12px;\n  color: var(--text-default, #1f2937);\n}\n\n.ai-dmn-gen-drd-section li {\n  margin: 2px 0;\n}\n\n.ai-dmn-gen-count {\n  color: var(--text-muted, #6b7280);\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.ai-dmn-gen-empty {\n  color: var(--text-muted, #6b7280);\n  font-style: italic;\n  font-size: 12px;\n  margin: 0;\n}\n\n/* Table preview (step 3) */\n\n.ai-dmn-gen-table {\n  overflow-x: auto;\n}\n\n.ai-dmn-gen-hp {\n  margin: 0 0 8px;\n  font-size: 12px;\n  color: var(--text-muted, #6b7280);\n}\n\n.ai-dmn-gen-table-preview {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.ai-dmn-gen-table-preview th,\n.ai-dmn-gen-table-preview td {\n  border: 1px solid var(--surface-border, #d1d5db);\n  padding: 4px 8px;\n  text-align: left;\n  vertical-align: top;\n}\n\n.ai-dmn-gen-table-preview th {\n  background: var(--surface-subtle, #f3f4f6);\n  font-weight: 600;\n}\n\n.ai-dmn-gen-table-preview .ai-dmn-gen-col-in {\n  background: rgba(37, 99, 235, 0.06);\n}\n\n.ai-dmn-gen-table-preview .ai-dmn-gen-col-out {\n  background: rgba(22, 163, 74, 0.06);\n}\n\n.ai-dmn-gen-rule-num {\n  text-align: center;\n  width: 32px;\n  color: var(--text-muted, #6b7280);\n}\n\n/* Scenarios (step 4) */\n\n.ai-dmn-gen-scenarios {\n  display: grid;\n  gap: 10px;\n}\n\n.ai-dmn-gen-scenario {\n  border: 1px solid var(--surface-border, #d1d5db);\n  border-radius: 4px;\n  padding: 8px 10px;\n  background: var(--surface-subtle, #f9fafb);\n}\n\n.ai-dmn-gen-scenario-name {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.ai-dmn-gen-scenario-cols {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.ai-dmn-gen-scenario-cols h5 {\n  margin: 0 0 2px;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted, #6b7280);\n}\n\n.ai-dmn-gen-scenario-cols pre {\n  margin: 0;\n  font-size: 11px;\n  background: rgba(0, 0, 0, 0.04);\n  padding: 4px 6px;\n  border-radius: 3px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.ai-dmn-gen-runchk {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 12px;\n  font-size: 12px;\n  color: var(--text-default, #1f2937);\n  cursor: pointer;\n}\n\n/* ── Prose mode (Camino 2 — NaLa2BPMN editable prose for DSPy) ─────────────── */\n\n.atlas-prose-mode {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", system-ui, sans-serif;\n  font-size: 14px;\n  line-height: 1.65;\n}\n\n.atlas-prose-mode .atlas-pr {\n  display: flex;\n  gap: 8px;\n  align-items: baseline;\n  padding: 4px 8px;\n  border-radius: 4px;\n  border-left: 3px solid transparent;\n  transition: background 120ms ease;\n}\n.atlas-prose-mode .atlas-pr:hover { background: rgba(148, 163, 184, 0.06); }\n\n.atlas-pr__lineno {\n  flex: 0 0 auto;\n  text-align: right;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 11px;\n  color: #64748b;\n  padding-right: 8px;\n  border-right: 1px solid rgba(100, 116, 139, 0.25);\n  user-select: none;\n}\n.atlas-pr__sym { flex: 0 0 16px; text-align: center; opacity: 0.7; }\n.atlas-pr__text { flex: 1; color: #e2e8f0; }\n\n/* Per-kind accent (left border + symbol colour) */\n.atlas-pr--start    { border-left-color: var(--atlas-outline-start); }\n.atlas-pr--start    .atlas-pr__sym { color: var(--atlas-outline-start); }\n.atlas-pr--end      { border-left-color: var(--atlas-outline-end); }\n.atlas-pr--end      .atlas-pr__sym { color: var(--atlas-outline-end); }\n.atlas-pr--decision { border-left-color: var(--atlas-outline-decision); }\n.atlas-pr--decision .atlas-pr__sym { color: var(--atlas-outline-decision); }\n.atlas-pr--parallel { border-left-color: var(--atlas-outline-gateway); }\n.atlas-pr--parallel .atlas-pr__sym { color: var(--atlas-outline-gateway); }\n.atlas-pr--wait     { border-left-color: var(--atlas-outline-event); }\n.atlas-pr--wait     .atlas-pr__sym { color: var(--atlas-outline-event); }\n.atlas-pr--task     { border-left-color: var(--atlas-outline-task); }\n.atlas-pr--task     .atlas-pr__sym { color: var(--atlas-outline-task); }\n\n/* Inline tokens highlighted inside the sentence text */\n.atlas-pr__actor {\n  display: inline-block;\n  padding: 1px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 999px;\n  background: rgba(37, 99, 235, 0.18);\n  color: #93c5fd;\n  margin: 0 1px;\n  vertical-align: baseline;\n}\n.atlas-pr__kw {\n  font-weight: 600;\n  border-radius: 3px;\n  padding: 0 3px;\n}\n.atlas-pr__kw--decision { color: var(--atlas-outline-decision); background: rgba(217, 119, 6, 0.12); }\n.atlas-pr__kw--parallel { color: var(--atlas-outline-gateway); background: rgba(124, 58, 237, 0.12); }\n.atlas-pr__kw--wait     { color: var(--atlas-outline-event);   background: rgba(8, 145, 178, 0.12); }\n.atlas-pr__kw--start    { color: var(--atlas-outline-start);   background: rgba(22, 163, 74, 0.12); }\n.atlas-pr__kw--end      { color: var(--atlas-outline-end);     background: rgba(220, 38, 38, 0.12); }\n\n.atlas-pr.atlas-pr--empty {\n  color: #64748b;\n  font-style: italic;\n  padding: 12px;\n}\n\n/* In prose mode (Camino 2 — DSPy), hide outline-only UI:\n   - the typed-outline legend (prefixes don't apply to prose)\n   - the \"Sugerir mejoras\" button (its endpoint targets typed-outline shape)\n   The mode is set in JS via data-input-format on #ai-gen-step-preview. */\n[data-input-format=\"prose\"] .ai-gen-outline-legend,\n[data-input-format=\"prose\"] #ai-gen-suggest { display: none; }\n\n/* ── Themis DMN wizard, two-phase editor (THEMIS_BACKEND_COMPLETION_PLAN B6) ── */\n\n#ai-dmn-gen-modal .ai-gen-modal__box {\n  max-width: 1100px;\n}\n\n.ai-dmn-gen-editor-grid {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 14px;\n  margin-top: 8px;\n  min-height: 420px;\n}\n\n.ai-dmn-gen-editor-col,\n.ai-dmn-gen-issues-col {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.ai-dmn-gen-editor-label,\n.ai-dmn-gen-issues-header {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  opacity: 0.65;\n  margin-bottom: 4px;\n}\n\n.ai-dmn-gen-outline-editor {\n  flex: 1 1 auto;\n  width: 100%;\n  font-family: ui-monospace, \"JetBrains Mono\", \"Fira Code\", Menlo, Consolas, monospace;\n  font-size: 12.5px;\n  line-height: 1.55;\n  padding: 10px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(15, 17, 25, 0.55);\n  color: #e6e6f5;\n  resize: vertical;\n  tab-size: 2;\n  white-space: pre;\n}\n\n.ai-dmn-gen-outline-editor:focus {\n  outline: none;\n  border-color: var(--themis-soft);\n  box-shadow: 0 0 0 2px rgba(var(--themis-rgb), 0.22);\n}\n\n.ai-dmn-gen-issues {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 8px 10px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  background: rgba(20, 22, 32, 0.45);\n}\n\n.ai-dmn-gen-issues-empty {\n  margin: 6px 0;\n  font-size: 12px;\n  opacity: 0.55;\n}\n\n.ai-dmn-gen-issues-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ai-dmn-gen-issue {\n  display: grid;\n  grid-template-columns: auto auto 1fr;\n  gap: 4px 8px;\n  align-items: baseline;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  background: rgba(255, 255, 255, 0.03);\n  border-left: 3px solid transparent;\n}\n\n.ai-dmn-gen-issue.is-error    { border-left-color: #ef4444; }\n.ai-dmn-gen-issue.is-warning  { border-left-color: #eab308; }\n.ai-dmn-gen-issue.is-info     { border-left-color: #38bdf8; }\n\n.ai-dmn-gen-issue-icon { font-size: 13px; }\n\n.ai-dmn-gen-issue-code {\n  font-family: ui-monospace, monospace;\n  font-size: 10.5px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.07);\n  padding: 1px 6px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.ai-dmn-gen-issue-msg {\n  grid-column: 3 / 4;\n  line-height: 1.4;\n}\n\n.ai-dmn-gen-issue-tip {\n  grid-column: 1 / -1;\n  font-size: 11.5px;\n  opacity: 0.75;\n  padding: 2px 4px 0 28px;\n}\n\n.ai-dmn-gen-run-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n  font-size: 13px;\n  opacity: 0.85;\n  cursor: pointer;\n}\n\n.ai-dmn-gen-run-toggle input[type=\"checkbox\"] {\n  accent-color: var(--themis);\n}\n\n/* ── Editor toolbar (Vista / Editar tabs) ─────────────────────────────── */\n\n.ai-dmn-gen-editor-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.ai-dmn-gen-view-tabs {\n  display: inline-flex;\n  gap: 4px;\n  background: rgba(255, 255, 255, 0.04);\n  padding: 3px;\n  border-radius: 6px;\n}\n\n.ai-dmn-gen-view-tab {\n  appearance: none;\n  border: 0;\n  background: transparent;\n  color: #d6d6e8;\n  font-size: 11.5px;\n  padding: 4px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  letter-spacing: 0.02em;\n  transition: background 0.15s, color 0.15s;\n}\n\n.ai-dmn-gen-view-tab:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.ai-dmn-gen-view-tab.is-active {\n  background: var(--themis-bg);\n  color: var(--themis-soft);\n}\n\n/* ── Rendered Markdown preview (step 2) ───────────────────────────────── */\n\n.ai-dmn-gen-outline-preview {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 12px 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  background: rgba(15, 17, 25, 0.55);\n  color: #e6e6f5;\n  font-family: ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.ai-dmn-gen-outline-preview__empty {\n  opacity: 0.55;\n  font-style: italic;\n}\n\n/* Heading levels — Themis palette */\n.ai-dmn-gen-outline-preview .md-h {\n  font-weight: 700;\n  margin: 12px 0 6px;\n  color: var(--themis-soft);\n  letter-spacing: 0.01em;\n}\n.ai-dmn-gen-outline-preview .md-h:first-child { margin-top: 0; }\n.ai-dmn-gen-outline-preview .md-h1 { font-size: 16px; color: #d8d0f0; }\n.ai-dmn-gen-outline-preview .md-h2 {\n  font-size: 14.5px;\n  color: var(--themis-soft);\n  border-bottom: 1px solid var(--themis-border);\n  padding-bottom: 3px;\n}\n.ai-dmn-gen-outline-preview .md-h3 { font-size: 13.5px; color: #b6abe0; }\n.ai-dmn-gen-outline-preview .md-h4,\n.ai-dmn-gen-outline-preview .md-h5,\n.ai-dmn-gen-outline-preview .md-h6 { font-size: 13px; color: #a89cd1; }\n\n/* Lists */\n.ai-dmn-gen-outline-preview .md-li {\n  position: relative;\n  padding: 1px 0 1px 14px;\n}\n.ai-dmn-gen-outline-preview .md-bullet {\n  color: #7b8aa8;\n  margin-right: 4px;\n}\n\n/* Paragraphs / empties */\n.ai-dmn-gen-outline-preview .md-p { margin: 2px 0; }\n.ai-dmn-gen-outline-preview .md-empty { height: 6px; }\n\n/* Tables */\n.ai-dmn-gen-outline-preview .md-tr {\n  display: grid;\n  grid-auto-flow: column;\n  grid-auto-columns: minmax(0, 1fr);\n  gap: 8px;\n  padding: 4px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  font-size: 12.5px;\n}\n.ai-dmn-gen-outline-preview .md-tr--sep {\n  border-bottom: 1px solid rgba(149, 92, 215, 0.4);\n  padding: 0;\n}\n.ai-dmn-gen-outline-preview .md-td {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n/* Inline tokens (colours) */\n.ai-dmn-gen-outline-preview .md-bold   { font-weight: 700; color: #ffd877; }\n.ai-dmn-gen-outline-preview .md-italic { font-style: italic; color: #c8d2ee; }\n.ai-dmn-gen-outline-preview .md-code {\n  font-family: ui-monospace, \"JetBrains Mono\", \"Fira Code\", Menlo, Consolas, monospace;\n  font-size: 11.8px;\n  background: rgba(255, 255, 255, 0.07);\n  padding: 1px 5px;\n  border-radius: 3px;\n  color: #ffb37a;\n}\n.ai-dmn-gen-outline-preview .md-key    { color: #6cc0ff; font-weight: 600; }\n.ai-dmn-gen-outline-preview .md-string { color: #a8e6a8; }\n.ai-dmn-gen-outline-preview .md-number { color: #f5a3ff; }\n.ai-dmn-gen-outline-preview .md-bool   { color: #ff9b6b; font-weight: 600; }\n\n/* Editor textarea is the same as before but no longer the only view */\n.ai-dmn-gen-outline-editor[hidden] { display: none !important; }\n.ai-dmn-gen-outline-preview[hidden] { display: none !important; }\n\n/* \"Arreglar errores\" button — uses the warning palette */\n#ai-dmn-gen-fix {\n  border-color: rgba(234, 179, 8, 0.55);\n  color: #f7e08c;\n  background: rgba(234, 179, 8, 0.08);\n}\n#ai-dmn-gen-fix:hover:not(:disabled) {\n  background: rgba(234, 179, 8, 0.18);\n  color: #fff5b8;\n}\n#ai-dmn-gen-fix:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Themis identity overrides for the DMN modal only ─────────────────── */\n\n#ai-dmn-gen-modal .ai-gen-modal__header {\n  background: var(--themis);\n}\n\n#ai-dmn-gen-modal .ai-gen-modal__btn--primary {\n  background: var(--themis);\n  border-color: var(--themis);\n  color: var(--themis-text);\n}\n#ai-dmn-gen-modal .ai-gen-modal__btn--primary:hover:not(:disabled) {\n  background: var(--themis-hover);\n  border-color: var(--themis-hover);\n}\n\n/* Step-1 description textarea — match the rest of the dark UI */\n#ai-dmn-gen-input {\n  width: 100%;\n  box-sizing: border-box;\n  background: rgba(15, 17, 25, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #e6e6f5;\n  font-size: 13px;\n  line-height: 1.6;\n  padding: 10px 12px;\n  resize: vertical;\n  outline: none;\n  font-family: inherit;\n  transition: border-color 150ms, box-shadow 150ms;\n}\n#ai-dmn-gen-input::placeholder { color: rgba(230, 230, 245, 0.35); }\n#ai-dmn-gen-input:focus {\n  border-color: var(--themis-soft);\n  box-shadow: 0 0 0 2px rgba(var(--themis-rgb), 0.22);\n}\n\n/* Long structured text — let the modal body scroll instead of pushing the\n   footer off-screen. Constrains both the wizard step 1 (large pasted text)\n   and step 2 (long outlines). */\n#ai-dmn-gen-modal .ai-gen-modal__box {\n  display: flex;\n  flex-direction: column;\n  max-height: 92vh;\n}\n#ai-dmn-gen-modal .ai-gen-step {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  max-height: calc(92vh - 56px);   /* leave room for the header */\n}\n#ai-dmn-gen-modal .ai-gen-step[hidden] { display: none; }\n#ai-dmn-gen-modal .ai-gen-modal__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n/* Editor pane: keep the preview/editor inside their column, allow them to\n   scroll instead of growing without bound. */\n.ai-dmn-gen-editor-grid { max-height: 60vh; }\n.ai-dmn-gen-outline-preview { max-height: 60vh; }\n.ai-dmn-gen-outline-editor  { max-height: 60vh; }\n\n/* Long unbroken tokens (URLs, IDs) inside the preview shouldn't force a\n   horizontal scrollbar — wrap them. */\n.ai-dmn-gen-outline-preview .md-p,\n.ai-dmn-gen-outline-preview .md-li,\n.ai-dmn-gen-outline-preview .md-td {\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n/* ── Friendly preview (narrative for non-technical users) ──────────────── */\n\n.ai-dmn-gen-outline-friendly {\n  flex: 1 1 auto;\n  min-height: 220px;\n  max-height: 60vh;\n  overflow-y: auto;\n  background: #1a2438;\n  border: 1px solid #2a3550;\n  border-radius: 6px;\n  padding: 12px 14px;\n  color: #d8e1f3;\n  line-height: 1.55;\n}\n\n.dmn-fp__empty {\n  padding: 24px;\n  text-align: center;\n  color: #6b7a98;\n  font-style: italic;\n}\n\n.dmn-fp__title {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  color: #ffd877;\n  border-bottom: 1px solid #2a3550;\n  padding-bottom: 8px;\n}\n\n.dmn-fp__section + .dmn-fp__section { margin-top: 18px; }\n\n.dmn-fp__h {\n  font-size: 13px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #b6abe0;\n  margin: 0 0 8px 0;\n}\n\n.dmn-fp__inputs-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dmn-fp__input {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  padding: 4px 0;\n  border-bottom: 1px dashed #2a3550;\n}\n\n.dmn-fp__input:last-child { border-bottom: none; }\n.dmn-fp__input-name { font-weight: 600; color: #6cc0ff; }\n.dmn-fp__input-type { color: #9aa6c4; font-size: 12.5px; }\n\n.dmn-fp__decision {\n  margin-top: 14px;\n  padding: 10px 12px;\n  background: #16213a;\n  border: 1px solid #2c3855;\n  border-radius: 6px;\n}\n\n.dmn-fp__decision-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.dmn-fp__step {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px; height: 22px;\n  border-radius: 50%;\n  background: #3a5fcd;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.dmn-fp__decision-title {\n  margin: 0;\n  font-size: 14px;\n  color: #ffd877;\n}\n\n.dmn-fp__decision-desc {\n  margin: 0 0 8px 0;\n  color: #9aa6c4;\n  font-style: italic;\n  font-size: 12.5px;\n}\n\n.dmn-fp__returns {\n  margin: 4px 0 8px 0;\n  color: #c8d2ee;\n  font-size: 12.5px;\n}\n\n.dmn-fp__rules-intro,\n.dmn-fp__formula-intro {\n  margin: 8px 0 4px 0;\n  color: #9aa6c4;\n  font-size: 12.5px;\n}\n\n.dmn-fp__rules {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  counter-reset: dmn-fp-rule;\n}\n\n.dmn-fp__rule {\n  display: flex;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 4px;\n}\n\n.dmn-fp__rule + .dmn-fp__rule { margin-top: 2px; }\n.dmn-fp__rule:hover { background: rgba(108, 192, 255, 0.06); }\n\n.dmn-fp__rule.is-fallback {\n  background: rgba(245, 163, 255, 0.06);\n  border-left: 2px solid #c878d8;\n  padding-left: 6px;\n}\n\n.dmn-fp__rule-num {\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  color: #6cc0ff;\n  min-width: 22px;\n}\n\n.dmn-fp__rule-body {\n  flex: 1;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 8px;\n  align-items: baseline;\n}\n\n.dmn-fp__rule-if,\n.dmn-fp__rule-and {\n  text-transform: lowercase;\n  color: #9aa6c4;\n  font-style: italic;\n}\n\n.dmn-fp__rule-arrow { color: #6cc0ff; font-weight: 700; }\n.dmn-fp__rule-outcome { color: #a8e6a8; font-weight: 600; }\n.dmn-fp__rule-fallback { color: #c878d8; font-style: italic; }\n.dmn-fp__rule-note { color: #9aa6c4; font-size: 12px; font-style: italic; }\n.dmn-fp__any { color: #6b7a98; font-style: italic; font-size: 12px; }\n\n.dmn-fp__expr {\n  background: rgba(245, 163, 255, 0.10);\n  color: #f5a3ff;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n}\n\n.dmn-fp__formula {\n  margin: 4px 0 0 0;\n  padding: 8px 10px;\n  background: #0f1830;\n  border: 1px solid #2a3550;\n  border-radius: 4px;\n  color: #f5a3ff;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n}\n\n.dmn-fp__context,\n.dmn-fp__list {\n  list-style: none;\n  margin: 4px 0 0 0;\n  padding: 0;\n}\n\n.dmn-fp__context li,\n.dmn-fp__list li {\n  padding: 2px 0;\n}\n\n.dmn-fp__uses {\n  margin: 8px 0 0 0;\n  padding-top: 6px;\n  border-top: 1px dashed #2a3550;\n  color: #9aa6c4;\n  font-size: 12px;\n}\n\n.dmn-fp__uses em { color: #6cc0ff; font-style: normal; font-weight: 600; }\n\n/* Scenarios */\n.dmn-fp__scenarios { list-style: none; margin: 0; padding: 0; }\n\n.dmn-fp__scenario {\n  padding: 6px 8px;\n  border-left: 2px solid #3a5fcd;\n  background: rgba(58, 95, 205, 0.08);\n  border-radius: 0 4px 4px 0;\n  margin-bottom: 6px;\n}\n\n.dmn-fp__scenario-title { margin: 0 0 2px 0; color: #ffd877; }\n.dmn-fp__scenario-given,\n.dmn-fp__scenario-expected { margin: 2px 0; color: #c8d2ee; font-size: 12.5px; }\n.dmn-fp__scenario em { color: #6cc0ff; font-style: normal; font-weight: 600; }\n\n.dmn-fp em {\n  color: #ffd877;\n  font-style: italic;\n}\n\n/* ── Issues — funcional/técnica view toggle ─────────────────────────────── */\n\n.ai-dmn-gen-issues-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.ai-dmn-gen-issues-tabs {\n  display: inline-flex;\n  background: #1a2438;\n  border: 1px solid #2a3550;\n  border-radius: 4px;\n  padding: 2px;\n}\n\n.ai-dmn-gen-issues-tab {\n  padding: 3px 8px;\n  background: transparent;\n  border: 0;\n  border-radius: 3px;\n  color: #9aa6c4;\n  font-size: 11.5px;\n  cursor: pointer;\n  transition: background 120ms ease, color 120ms ease;\n}\n\n.ai-dmn-gen-issues-tab:hover { color: #d8e1f3; }\n.ai-dmn-gen-issues-tab.is-active {\n  background: #3a5fcd;\n  color: #fff;\n  font-weight: 600;\n}\n\n.ai-dmn-gen-issues-group {\n  margin-bottom: 12px;\n  background: #16213a;\n  border: 1px solid #2c3855;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.ai-dmn-gen-issues-group__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 10px;\n  background: #1a2438;\n  border-bottom: 1px solid #2c3855;\n}\n\n.ai-dmn-gen-issues-group__title { font-weight: 700; color: #ffd877; font-size: 12.5px; }\n.ai-dmn-gen-issues-group__count { color: #9aa6c4; font-size: 11.5px; }\n\n.ai-dmn-gen-issues-group .ai-dmn-gen-issues-list {\n  margin: 0;\n  padding: 6px 10px;\n}\n\n.ai-dmn-gen-issue-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ai-dmn-gen-issue-title {\n  margin: 0;\n  color: #d8e1f3;\n  font-size: 12.5px;\n}\n\n.ai-dmn-gen-issue-body {\n  margin: 0;\n  color: #9aa6c4;\n  font-size: 12px;\n  font-style: italic;\n}\n\n.ai-dmn-gen-issues-hidden-note {\n  margin: 8px 0 0 0;\n  padding-top: 6px;\n  border-top: 1px dashed #2a3550;\n  color: #6b7a98;\n  font-size: 11.5px;\n}\n\n.ai-dmn-gen-issues-tech-link {\n  background: transparent;\n  border: 0;\n  color: #6cc0ff;\n  cursor: pointer;\n  padding: 0;\n  font: inherit;\n  text-decoration: underline;\n}\n\n.ai-dmn-gen-issues-tech-link:hover { color: #88cfff; }\n\n/* ── Apply confirm overlay ──────────────────────────────────────────────── */\n\n.ai-dmn-gen-apply-confirm {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ai-dmn-gen-apply-confirm[hidden] { display: none; }\n\n.ai-dmn-gen-apply-confirm__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(8, 14, 28, 0.7);\n}\n\n.ai-dmn-gen-apply-confirm__box {\n  position: relative;\n  background: #1a2438;\n  border: 1px solid #2c3855;\n  border-radius: 8px;\n  padding: 18px 22px;\n  width: min(520px, 90%);\n  max-height: 80%;\n  overflow-y: auto;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);\n}\n\n.ai-dmn-gen-apply-confirm__box h4 {\n  margin: 0 0 12px 0;\n  font-size: 15px;\n  color: #ffd877;\n}\n\n.ai-dmn-gen-apply-confirm__lead {\n  margin: 0 0 8px 0;\n  color: #c8d2ee;\n  font-size: 13px;\n}\n\n.ai-dmn-gen-apply-confirm__list {\n  margin: 6px 0 12px 0;\n  padding-left: 18px;\n  color: #d8e1f3;\n  font-size: 12.5px;\n}\n\n.ai-dmn-gen-apply-confirm__list li { margin: 3px 0; }\n\n.ai-dmn-gen-apply-confirm__hidden {\n  margin: 6px 0 0 0;\n  color: #9aa6c4;\n  font-size: 11.5px;\n  font-style: italic;\n}\n\n.ai-dmn-gen-apply-confirm__footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n  flex-wrap: wrap;\n}\n\n/* The wizard box already has position:relative — the confirm overlay uses it\n   as its positioning context (declared higher up in this file). */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
